// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planning__breadcrumb {
  display: none;
  margin-bottom: 35px;
}
.planning__content {
  display: flex;
  flex-direction: column;
  min-height: calc(100dvh - 56px);
}
.planning__content--right {
  position: relative;
  display: flex;
  flex: 1 1;
  justify-content: space-between;
  flex-direction: column;
}
.planning__wrapper--right {
  width: 100%;
  padding: 24px 16px;
}
.planning__step {
  width: 100%;
}
.planning__step--title {
  display: none;
  font-size: 27px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
  margin-bottom: 16px;
  align-items: center;
  gap: 5px;
}
.planning__step--title span {
  font-size: 13px;
  font-weight: 400;
}
.planning__footer {
  position: sticky;
  bottom: 0;
  left: 0;
  padding: 16px;
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  background-color: var(--sebrae-white);
}
.planning__footer-info {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
}
.planning__footer-info .template-buttons-wrapper {
  display: flex;
  gap: 16px;
}
@media screen and (max-width: 767px) {
  .planning__footer-info .template-buttons-wrapper {
    width: 70dvw;
    max-width: 70dvw;
  }
}
@media screen and (max-width: 448px) {
  .planning__footer-info .template-buttons-wrapper {
    width: 64dvw;
    max-width: 64dvw;
  }
}
@media screen and (max-width: 768px) {
  .planning__footer-info {
    margin-left: unset !important;
  }
}
@media screen and (max-width: 624px) {
  .planning__footer-info {
    width: 100%;
    justify-content: space-between;
  }
}
.planning__footer.under-buttons {
  z-index: 0;
}
.planning__footer .id-holder {
  padding: 8px;
  background-color: var(--sebrae-white-3);
  border: 1px solid #8FB8EF;
  color: var(--sebrae-blue-2);
  border-radius: 100px;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
  transition: 0.15s ease-in-out;
}
.planning__footer .id-holder:hover {
  opacity: 0.65;
}
.planning__footer button {
  flex: 1 1;
}
.planning__footer button img {
  width: 18px;
  height: 18px;
}
@media screen and (max-width: 624px) {
  .planning__footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
.planning .step--info {
  padding-bottom: 16px;
  border-bottom: 1px solid var(--sebrae-light-gray4);
  margin-bottom: 32px;
}
.planning .step--title, .planning .step--subtitle {
  color: var(--sebrae-gray);
}
.planning .step--title {
  font-size: 16px;
  margin-bottom: 8px;
  line-height: 1.2;
}
.planning .step--subtitle {
  font-size: 13px;
  margin-bottom: 8px;
  line-height: 1.2;
}
.planning .step--subtitle.icon {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}
.planning .step .BaSe--grid {
  gap: 16px !important;
}
.planning .step .error-message {
  font-size: 11px;
  color: var(--sebrae-red);
}
@media screen and (min-width: 375px) {
  .planning .step .error-message {
    font-size: 12px;
  }
}
.planning .step.variable-indirect-costs .BaSe--grid, .planning .step.monthly-average .BaSe--grid {
  gap: 0 !important;
}
.planning .step.variable-indirect-costs .BaSe--grid .BaSe--grid, .planning .step.monthly-average .BaSe--grid .BaSe--grid {
  gap: 16px !important;
}
.planning .step.total-investment .BaSe--grid {
  gap: 0 !important;
}
.planning .step.variable-indirect-costs .step--info, .planning .step.total-investment .step--info, .planning .step.receipt-deadline .step--info, .planning .step.payment-terms .step--info, .planning .step.inventory-turnover .step--info {
  margin-bottom: 16px;
}
.planning .step.variable-indirect-costs .accordion-modal, .planning .step.total-investment .accordion-modal, .planning .step.receipt-deadline .accordion-modal, .planning .step.payment-terms .accordion-modal, .planning .step.inventory-turnover .accordion-modal {
  margin-bottom: 24px;
}
.planning .step.variable-indirect-costs .grid-buttons-area .BaSe--grid .BaSe--grid-item:last-child, .planning .step.total-investment .grid-buttons-area .BaSe--grid .BaSe--grid-item:last-child, .planning .step.receipt-deadline .grid-buttons-area .BaSe--grid .BaSe--grid-item:last-child, .planning .step.payment-terms .grid-buttons-area .BaSe--grid .BaSe--grid-item:last-child, .planning .step.inventory-turnover .grid-buttons-area .BaSe--grid .BaSe--grid-item:last-child {
  padding-top: 14px;
}
.planning .step.inventory-turnover .btn-add-more {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px auto 0;
  color: var(--sebrae-blue-6);
  font-size: 13px;
  font-weight: 700;
}
.planning .step.inventory-turnover .result .input-100 .BaSe--input {
  margin: 0;
}
.planning .step.inventory-turnover .result .input-100 .BaSe--input .BaSe--input-wrapper {
  border-radius: 4px;
  overflow: hidden;
}
.planning .step.inventory-turnover .result .input-100 .BaSe--input input {
  background: var(--sebrae-white);
  border-radius: 4px !important;
  border-width: 2px !important;
  border-image-slice: 1 !important;
  border-image-source: linear-gradient(to right, #3b4aff 0%, #40bbff 100%) !important;
}
.planning .step.inventory-turnover .result .input-not-100 .BaSe--input {
  margin: 0;
}
.planning .step.inventory-turnover .result .input-not-100 .BaSe--input .BaSe--input-wrapper {
  border-radius: 4px;
  overflow: hidden;
}
.planning .step.inventory-turnover .result .input-not-100 .BaSe--input input {
  background: var(--sebrae-white);
  border-radius: 4px !important;
  border-width: 2px !important;
  border-image-slice: 1 !important;
  border-image-source: linear-gradient(to right, #ff3b3b 0%, #760303 100%) !important;
}
.planning .step.inventory-turnover .text-muted {
  margin-top: 32px;
  display: inline-block;
}
.planning .step.cash-flow .modal-second-section,
.planning .step.cash-flow .modal-third-section,
.planning .step.cash-flow .modal-fourth-section {
  gap: 16px;
  width: 100%;
  display: flex;
  margin-top: 24px;
  justify-content: space-between;
}
.planning .step.cash-flow .modal-fourth-section {
  margin-bottom: 34px;
}
.planning .step.cash-flow .modal-fourth-section div {
  flex: 1 1;
}
.planning .step.cash-flow .modal-fampe-area h3 {
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  margin-bottom: 1px;
}
.planning .step.cash-flow .fampe-range-status {
  padding: 16px;
  margin: 32px 0;
  border-radius: 4px;
  border: 1px solid var(--sebrae-dark-green3);
  background-color: var(--sebrae-light-green4);
}
.planning .step.cash-flow .fampe-range-status h3 {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--sebrae-dark-green3);
}
.planning .step.cash-flow .fampe-range-status p {
  font-size: 13px;
  font-weight: 400;
  color: var(--sebrae-dark-green3);
}
.planning .step.cash-flow .fampe-range-status.fampe-80 {
  border-color: var(--sebrae-dark-green3);
  background-color: var(--sebrae-light-green4);
}
.planning .step.cash-flow .fampe-range-status.fampe-80 h3,
.planning .step.cash-flow .fampe-range-status.fampe-80 p {
  color: var(--sebrae-dark-green3);
}
.planning .step.cash-flow .fampe-range-status.fampe-over {
  border-color: #ffbf40;
  background-color: #fec;
}
.planning .step.cash-flow .fampe-range-status.fampe-over h3,
.planning .step.cash-flow .fampe-range-status.fampe-over a,
.planning .step.cash-flow .fampe-range-status.fampe-over p {
  color: #8f6b24;
}
.planning .step.cash-flow .fampe-range-status.fampe-under {
  border-color: #2e5de6;
  background-color: #cfe2fc;
}
.planning .step.cash-flow .fampe-range-status.fampe-under h3,
.planning .step.cash-flow .fampe-range-status.fampe-under p {
  color: #2e5de6;
}
.planning .step.cash-flow .values-area .main-value {
  gap: 6px;
  width: 100%;
  display: flex;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 32px;
  align-items: flex-start;
  background-color: var(--sebrae-white-3);
  border: 1px solid var(--sebrae-light-gray5);
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
}
.planning .step.cash-flow .values-area .main-value .bg-img {
  padding: 8px;
  border-radius: 150px;
  background-color: var(--sebrae-light-blue3);
}
.planning .step.cash-flow .values-area .main-value img {
  width: 24px;
  object-fit: contain;
}
.planning .step.cash-flow .values-area .main-value h3 {
  color: var(--sebrae-blue);
  font-family: Figtree;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 6px;
  margin-bottom: 12px;
}
.planning .step.cash-flow .values-area .other-values {
  gap: 16px;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
}
@media (min-width: 550px) {
  .planning .step.cash-flow .values-area .other-values {
    flex-direction: row;
  }
}
.planning .step.cash-flow .values-area .other-values:first-child {
  margin-top: 0;
}
.planning .step.cash-flow .values-area .other-values-value {
  flex: 1 1;
  gap: 6px;
  display: flex;
  padding: 16px;
  border-radius: 8px;
  align-items: flex-start;
  border: 1px solid var(--sebrae-light-gray5);
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
}
.planning .step.cash-flow .values-area .other-values-value-text {
  gap: 4px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.planning .step.cash-flow .values-area .other-values-value-text h3 {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 700;
  font-style: normal;
  color: var(--sebrae-blue);
}
.planning .step.cash-flow .values-area .other-values img {
  width: 16px;
  object-fit: contain;
}
.planning .step.cash-flow .values-area .other-values .bg-img {
  padding: 8px;
  border-radius: 150px;
  background-color: var(--sebrae-light-blue3);
}
.planning .step.cash-flow .values-area .other-values .bg-img .percentage {
  width: 16px;
  height: 16px;
  padding: 2px;
}
.planning .step.cash-flow .modal-button-area {
  gap: 8px;
  display: flex;
  margin-top: 32px;
  justify-content: end;
}
.planning .step.cash-flow .modal-button-area button {
  max-width: 175px;
}
.planning .step.cash-flow .modal-button-area-button {
  max-width: 68px;
}
.planning .step.cash-flow .btns-area {
  gap: 16px;
  display: flex;
  margin-top: 16px;
  flex-direction: column;
}
@media (min-width: 769px) {
  .planning .step.cash-flow .btns-area {
    flex-direction: row;
  }
  .planning .step.cash-flow .btns-area button:last-child {
    max-width: 223px;
  }
}
.planning .step.cash-flow .new-credit-area {
  margin-top: 16px;
}
.planning .step.cash-flow .new-credit-area-buttons {
  gap: 16px;
  display: flex;
  margin-top: 16px;
}
.planning .step.cash-flow .cash-flow__title {
  color: var(--sebrae-blue-6);
  font-family: Campuni;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 5px;
}
.planning .step.cash-flow .cash-flow__wrapper {
  position: relative;
  overflow: hidden;
  margin: -2px -2px;
  padding: 2px;
}
.planning .step.cash-flow .wrapper-flux {
  min-width: 250px;
}
.planning .step.cash-flow .wrapper-flux .default, .planning .step.cash-flow .wrapper-flux .card-flux, .planning .step.cash-flow .wrapper-flux h3, .planning .step.cash-flow .wrapper-flux .date {
  padding: 16px;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
  margin-bottom: 16px;
  justify-content: space-between;
  font-size: 14px;
}
.planning .step.cash-flow .wrapper-flux .date {
  border-radius: 4px;
  border: 1px solid var(--sebrae-light-gray4);
  background: var(--sebrae-white-4);
  height: 40px;
  color: var(--sebrae-gray);
  font-style: normal;
  font-weight: 400;
  line-height: 23.3px;
}
.planning .step.cash-flow .wrapper-flux .date.not-menu {
  background-color: transparent;
  box-shadow: none;
  border: 0;
  opacity: 0;
}
.planning .step.cash-flow .wrapper-flux h3 {
  border-radius: 4px;
  background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
  height: 48px;
  color: var(--sebrae-white);
  font-style: normal;
  font-weight: 700;
  line-height: 23.3px;
}
.planning .step.cash-flow .wrapper-flux h3.gradient {
  background: var(--sebrae-white);
  color: var(--sebrae-gray);
}
.planning .step.cash-flow .wrapper-flux h3.has-balance {
  background: linear-gradient(15deg, #9285f9 0%, #cd5be8 100%);
}
.planning .step.cash-flow .wrapper-flux .exits .card-flux:first-of-type {
  padding: 10px 15px;
}
.planning .step.cash-flow .wrapper-flux .exits .card-flux:first-of-type.output-open {
  min-height: 48px;
}
.planning .step.cash-flow .wrapper-flux .exits .card-flux:first-of-type.output-closed {
  min-height: 56px;
}
.planning .step.cash-flow .wrapper-flux .exits .empty {
  background: transparent;
  box-shadow: none;
}
.planning .step.cash-flow .wrapper-flux .exits .empty p {
  visibility: hidden;
}
.planning .step.cash-flow .wrapper-flux .exits .content {
  width: 100%;
}
.planning .step.cash-flow .wrapper-flux .wrapper-card .card-flux {
  margin-bottom: 0;
  padding: 10px 15px;
}
.planning .step.cash-flow .wrapper-flux .wrapper-card .card-flux:first-child {
  margin-bottom: 14px;
}
.planning .step.cash-flow .wrapper-flux .wrapper-card .card-flux:last-child {
  margin-bottom: 15px;
}
.planning .step.cash-flow .wrapper-flux .wrapper-card .card-flux p {
  padding: 0;
}
.planning .step.cash-flow .wrapper-flux .wrapper-card .card-flux__strong {
  font-size: 16px;
  font-weight: 700;
}
.planning .step.cash-flow .wrapper-flux .card-flux {
  border-radius: 4px;
  background: var(--sebrae-white);
  color: var(--sebrae-gray);
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
  width: 100%;
  align-items: center;
  min-height: 56px;
}
.planning .step.cash-flow .wrapper-flux .card-flux-gray {
  background: var(--sebrae-light-gray4);
  color: var(--sebrae-gray);
}
.planning .step.cash-flow .wrapper-flux .card-flux-gray.active {
  background-color: var(--sebrae-light-blue3);
  color: var(--sebrae-blue-6);
}
.planning .step.cash-flow .wrapper-flux .card-flux .title {
  gap: 8px;
  display: flex;
  min-height: 35px;
  align-items: center;
  margin-bottom: 18px;
}
.planning .step.cash-flow .wrapper-flux .card-flux .title img {
  cursor: pointer;
}
.planning .step.cash-flow .wrapper-flux .card-flux .title.title-collapsed {
  margin-bottom: 0 !important;
}
.planning .step.cash-flow .wrapper-flux .card-flux .title.title-expanded {
  margin-bottom: 18px !important;
}
.planning .step.cash-flow .wrapper-flux .card-flux .title-values {
  width: 100%;
}
.planning .step.cash-flow .wrapper-flux .card-flux .title-right {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.planning .step.cash-flow .wrapper-flux .card-flux .title-exits {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.planning .step.cash-flow .wrapper-flux .card-flux .title-exits p {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  color: var(--sebrae-gray);
}
.planning .step.cash-flow .wrapper-flux .card-flux .title-exits:last-of-type p {
  padding: 0;
}
.planning .step.cash-flow .wrapper-flux .card-flux .title-exits .action-buttons {
  gap: 10px;
  display: flex;
  padding-right: 16px;
}
.planning .step.cash-flow .wrapper-flux .card-flux .title-exits .action-buttons.is-disabled > *:last-child {
  cursor: not-allowed !important;
  opacity: 0.4;
  filter: grayscale(1);
}
.planning .step.cash-flow .wrapper-flux .card-flux p {
  color: var(--sebrae-dark-gray2);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23.3px;
  padding-bottom: 17px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.planning .step.cash-flow .wrapper-flux .card-flux p:last-child {
  padding: 0;
}
.planning .step.cash-flow .wrapper-flux .card-flux .arrow {
  border: 1px solid var(--sebrae-dark-gray2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.planning .step.cash-flow .wrapper-flux .card-flux.small {
  padding: 8px 15px;
  min-height: 40.3px;
  margin-bottom: 0 !important;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance {
  flex-direction: column;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance.expanded {
  max-height: 100px;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance.collapsed {
  min-height: 56px !important;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance .header {
  gap: 8px;
  width: 100%;
  display: flex;
  padding-top: 2px;
  align-items: center;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance .header-content {
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: space-between;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance .header .icon-arrow img {
  cursor: pointer;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance .has-balance {
  width: 100%;
  margin-top: 5px;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance p {
  padding: 0;
  margin: 0 0 2px;
  font-size: 13px;
  line-height: 1.3;
  color: var(--sebrae-dark-gray2);
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance.has-balance {
  min-height: 100px;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance.small {
  min-height: 56px;
  margin-bottom: 60px !important;
  justify-content: center;
  align-items: start;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance.small.expanded {
  margin-bottom: 60px !important;
}
.planning .step.cash-flow .wrapper-flux .card-flux.balance.small.collapsed {
  margin-bottom: 16px !important;
}
.planning .step.cash-flow .wrapper-flux.title {
  min-width: 100%;
}
.planning .step.cash-flow .wrapper-flux.dynamic .exits .card-flux {
  margin-bottom: 8px;
}
.planning .step.cash-flow .wrapper-flux.dynamic .exits .card-flux-value {
  gap: 8px;
  display: flex;
  align-items: center;
}
.planning .step.cash-flow .SettingsSliderCashFlow.slick-slider {
  margin: 0 -16px !important;
}
.planning .step.cash-flow .SettingsSliderCashFlow .slick-track {
  display: flex !important;
}
.planning .step.cash-flow .SettingsSliderCashFlow .slick-slide {
  height: inherit !important;
}
.planning .step.cash-flow .SettingsSliderCashFlow .slick-slide div:first-child {
  height: 100%;
}
.planning .step.cash-flow .SettingsSliderCashFlow .slick-list .wrapper-flux {
  padding-left: 15px;
}
.planning .step.cash-flow .SettingsSliderCashFlow .slick-dots {
  position: relative;
  bottom: 0;
}
.planning .step.cash-flow .SettingsSliderCashFlow .slick-dots li {
  width: 18px;
  height: 10px;
}
.planning .step.cash-flow .SettingsSliderCashFlow .slick-dots li button {
  background-color: #005eb8;
  border-radius: 50%;
  opacity: 1;
  width: 10px;
  height: 10px;
  transition: 0.3s;
  font-size: 1px;
}
.planning .step.cash-flow .SettingsSliderCashFlow .slick-dots li button:before {
  content: none;
}
.planning .step.cash-flow .SettingsSliderCashFlow .slick-dots li.slick-active button {
  border-radius: 66.667px;
  width: 18px;
}
@media (min-width: 767px) {
  .planning .step.cash-flow .SettingsSliderCashFlow .slick-list {
    overflow: visible;
  }
}
.planning .step.cash-flow .SettingsSliderCashFlow .wrapper-flux {
  position: relative;
  height: 100%;
  padding-bottom: 72px;
}
.planning .step.cash-flow .SettingsSliderCashFlow .wrapper-flux .capacity {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  width: calc(100% - 15px);
  margin: 0 0 0 auto;
  padding: 10px 16px;
}
.planning .step.cash-flow .SettingsSliderCashFlow.empty .wrapper-flux {
  padding-left: 0;
}
.planning .step.cash-flow .SettingsSliderCashFlow.empty .wrapper-flux .capacity {
  width: 100%;
}
.planning .step.cash-flow .label-installments {
  padding: 10px 0;
  border-top: 1px solid var(--sebrae-light-gray4);
  margin-top: 16px;
}
.planning .step.cash-flow .form-date .description {
  font-weight: 600;
}
.planning .step.cash-flow .form-date .description span {
  color: var(--sebrae-gray);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23.3px;
  display: block;
  padding-top: 16px;
}
.planning .step.cash-flow .form-date label {
  color: var(--sebrae-gray) !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 5px;
}
.planning .step.cash-flow .form-initial-values .description {
  font-weight: 500;
  padding-bottom: 16px;
}
.planning .step.cash-flow .form-initial-values .wrapper-date {
  max-width: 50%;
  margin-bottom: 16px;
}
.planning .step.cash-flow .form-initial-values label {
  color: var(--sebrae-dark-gray2) !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 5px;
}
.planning .step.cash-flow .date .currency {
  padding: 10px 0 0;
}
.planning .step.cash-flow .date .wrapper-date {
  display: flex;
  gap: 20px;
}
.planning .step.cash-flow .date .wrapper-date > div {
  width: 100%;
}
.planning .step.cash-flow .date .inputs.months {
  display: flex;
  gap: 20px;
}
.planning .step.cash-flow .BaSe--checkbox div:last-child {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  width: 18px;
  height: 18px;
}
.planning .step.cash-flow .additional-month {
  max-height: 170px;
  overflow: auto;
  padding-right: 15px;
  margin-right: -10px;
  margin-top: 15px;
}
.planning .step.cash-flow .wrapper-button {
  padding: 20px 0 10px;
  text-align: right;
}
.planning .step.cash-flow .wrapper-button button {
  background-color: var(--sebrae-blue);
  color: var(--sebrae-white);
  border-radius: 4px;
  height: 40px;
  padding: 0 15px;
}
.planning .step.cash-flow button:disabled {
  opacity: 0.7;
  cursor: no-drop;
}
.planning .step.cash-flow .cash-flow__quick-view {
  position: relative;
  margin-top: 24px;
}
.planning .step.cash-flow .cash-flow__quick-view.mobile .BaSe--select {
  margin-bottom: 8px;
}
.planning .step.cash-flow .cash-flow__quick-view.mobile .clear {
  text-align: right;
}
.planning .step.cash-flow .cash-flow__quick-view.mobile .link {
  color: var(--sebrae-blue-6);
  font-size: 13px;
}
.planning .step.cash-flow .cash-flow__quick-view.desktop {
  display: none;
}
.planning .step.cash-flow .cash-flow__quick-view.desktop h6 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 15px;
  color: var(--sebrae-blue-6);
}
.planning .step.cash-flow .cash-flow__quick-view.desktop .months {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.planning .step.cash-flow .cash-flow__quick-view.desktop .months .month {
  width: 140px;
  height: 40px;
  border: 1px solid var(--sebrae-light-gray2);
  border-radius: 4px;
  padding: 4px;
  font-size: 13px;
  font-weight: 400;
  color: var(--sebrae-gray);
  background: transparent;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.planning .step.cash-flow .cash-flow__quick-view.desktop .months .month.active {
  background-color: var(--sebrae-blue-6);
  border-color: var(--sebrae-blue-6);
  color: var(--sebrae-white);
  font-weight: 700;
}
@media screen and (min-width: 375px) {
  .planning .step.cash-flow .wrapper-flux .default, .planning .step.cash-flow .wrapper-flux .date, .planning .step.cash-flow .wrapper-flux h3, .planning .step.cash-flow .wrapper-flux .card-flux {
    font-size: 16px;
  }
}
@media screen and (min-width: 767px) {
  .planning .step.cash-flow .slick-initialized .wrapper-flux {
    min-width: 302px;
    width: 302px;
  }
  .planning .step.cash-flow .wrapper-flux {
    min-width: 286px;
    width: 286px;
  }
  .planning .step.cash-flow .wrapper-flux.dynamic .exits .card-flux.small p {
    color: var(--sebrae-gray);
  }
  .planning .step.cash-flow .wrapper-flux.dynamic .exits .card-flux__strong {
    color: var(--sebrae-gray);
  }
  .planning .step.cash-flow .wrapper-flux .horizontal-bar {
    border-bottom: 1px solid var(--sebrae-light-gray4);
    margin-bottom: 16px;
  }
  .planning .step.cash-flow .wrapper-flux .horizontal-bar.without-border {
    border-bottom: 1px solid transparent;
    margin-bottom: 16px;
  }
  .planning .step.cash-flow .additional-month {
    max-height: 280px;
    gap: 0 16px;
  }
  .planning .step.cash-flow .date .BaSe--select,
  .planning .step.cash-flow .date .wrapper-date div {
    max-width: 204px;
  }
  .planning .step.cash-flow .date .inputs.months .wrapper-select,
  .planning .step.cash-flow .date .inputs.months .wrapper-date {
    flex: 1 1;
  }
}
@media screen and (min-width: 769px) and (max-width: 1023px) {
  .planning .step.cash-flow .SettingsSliderCashFlow.empty {
    padding-left: 15px;
  }
}
@media screen and (min-width: 1024px) {
  .planning .step.cash-flow .SettingsSliderCashFlow {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    gap: 16px;
  }
  .planning .step.cash-flow .cash-flow__wrapper {
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #d9d9d9 transparent;
  }
  .planning .step.cash-flow .wrapper-flux.title {
    margin: 15px 0 23px;
  }
  .planning .step.cash-flow .wrapper-flux .capacity {
    width: 100% !important;
    margin: 0 !important;
  }
  .planning .step.cash-flow .cash-flow__quick-view.desktop {
    display: block;
  }
  .planning .step.cash-flow .cash-flow__quick-view.mobile {
    display: none;
  }
  .planning .step.cash-flow .additional-month {
    max-height: 160px;
  }
}
@media screen and (min-width: 1280px) {
  .planning .step.cash-flow .wrapper-button {
    padding-top: 10px;
    padding-bottom: 0;
  }
  .planning .step.cash-flow .additional-month {
    max-height: 100%;
  }
  .planning .step.cash-flow .dialog-exists .wrapper-modal {
    max-height: 98dvh;
  }
  .planning .step.cash-flow .dialog-exists .modal-body {
    height: 520px;
    overflow-y: auto;
  }
}
.planning .step.results {
  max-width: 100% !important;
}
.planning .step.results .accordion-block-tip {
  padding: 0 24px 24px;
}
.planning .step.results .accordion-block-tip p {
  font-size: 13px;
}
.planning .step.results .title-result {
  font-size: 16px;
  padding-bottom: 19px;
}
.planning .step.results .accordion-content-internal {
  padding-bottom: 16px;
}
.planning .step.results .accordion-content-internal .first-block {
  flex: 1 1;
}
.planning .step.results .accordion-content-internal .first-block h6 {
  font-size: 19px;
  font-weight: 700;
  text-align: center;
}
.planning .step.results .accordion-content-internal .first-block p {
  font-size: 13px;
  max-width: 139px;
}
.planning .step.results .accordion-content-internal .first-block span {
  display: flex;
  padding-right: 16px;
  align-items: center;
  justify-content: space-between;
}
.planning .step.results .accordion-content-internal .second-block {
  flex: 1 1;
  gap: 8px;
  display: flex;
  padding: 16px;
  border-radius: 4px;
  align-items: center;
  flex-direction: column;
  border: 1px solid #d4dadd;
}
.planning .step.results .accordion-content-internal .second-block h6 {
  font-size: 11px;
}
.planning .step.results .accordion-content-internal .second-block p {
  font-size: 11px;
  font-style: italic;
  text-align: center;
}
.planning .step.results .accordion-content-internal .second-block p span {
  font-weight: 700;
}
.planning .step.results .accordion-content-internal .second-block-title {
  gap: 4.5px;
  display: flex;
  align-items: center;
}
.planning .step.results .accordion-content-internal .second-block-title img {
  width: 11px;
  height: 11px;
}
.planning .step.results .sections-bar {
  margin-bottom: 24px;
  border-bottom: 1px solid #3c4143;
}
.planning .step.results .sections-bar.internal {
  margin-bottom: 0;
  margin: 16px 0;
}
.planning .step.results .sections-bar.with-top {
  margin-top: 24px;
}
.planning .step.results .sections-bar.light {
  border-color: var(--sebrae-light-gray4) !important;
}
.planning .step.results .sections-bar.without-top {
  margin: 0;
  margin-bottom: 16px;
}
.planning .step.results .sections-bar.external {
  margin-bottom: 0;
  margin: 24px 0;
}
.planning .step.results .notes-modal {
  display: flex;
  flex-direction: column;
  align-items: end;
}
.planning .step.results .notes-modal span {
  font-weight: bold;
}
.planning .step.results .results-and-calculations {
  gap: 8px;
  display: flex;
  flex-direction: column;
}
.planning .step.results .results-and-calculations.special-result {
  margin-bottom: 24px;
}
.planning .step.results .results-and-calculations .second-block {
  flex: 1 1;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #d4dadd;
}
.planning .step.results .results-and-calculations .second-block-title {
  gap: 4.5px;
  display: flex;
  align-items: center;
  padding-bottom: 16px;
}
.planning .step.results .results-and-calculations .second-block-title h6 {
  font-size: 13px;
}
.planning .step.results .results-and-calculations .second-block-title img {
  width: 11px;
  height: 11px;
}
.planning .step.results .results-and-calculations .second-block-content {
  padding-bottom: 24px;
}
.planning .step.results .results-and-calculations .second-block-content span {
  font-weight: 700;
}
.planning .step.results .results-and-calculations .second-block-content h6,
.planning .step.results .results-and-calculations .second-block-content p {
  font-size: 13px;
}
.planning .step.results .results-and-calculations .second-block-content p {
  margin-top: 8px;
  color: #3c4143;
  font-style: italic;
}
.planning .step.results .results-information {
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid var(--sebrae-light-gray4);
}
.planning .step.results .results-information.special-results {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.planning .step.results .results-information__data {
  padding-left: 16px;
  display: flex;
  flex-wrap: wrap;
  flex: 1 1;
  align-items: stretch;
  justify-content: space-between;
  min-height: 56px;
  border-bottom: 1px solid var(--sebrae-light-gray4);
  margin-bottom: 0 !important;
}
.planning .step.results .results-information__data.no-border {
  flex: 1 1;
  border: none !important;
}
.planning .step.results .results-information__info {
  width: 50%;
  display: flex;
  padding: 8px 0;
  font-size: 13px;
  align-items: center;
  word-wrap: break-word;
}
.planning .step.results .results-information__value {
  width: 50%;
  display: flex;
  font-size: 13px;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}
.planning .step.results .results-information__value.highlighted {
  font-size: 16px;
  min-height: 56px;
  background-color: var(--sebrae-light-blue3);
  padding: 4px 0;
}
.planning .step.results .results-information__value.big-number {
  font-size: 11px;
}
.planning .step.results .message-observation {
  text-align: end;
}
.planning .step.results .message-observation p {
  font-size: 13px;
  padding-top: 5px;
}
.planning .step.results .second-tip-block h6 {
  font-size: 20px;
  font-weight: 900;
}
.planning .step.results .bar {
  border-bottom: 1px solid var(--sebrae-light-gray4);
  margin: 24px 0;
}
.planning .step.results .bar.last {
  margin: 48px 0 24px;
}
.planning .step.results .title {
  padding: 24px 0 8px;
}
.planning .step.results .title.square-title {
  padding: 0;
  padding-bottom: 16px;
}
.planning .step.results .goal {
  padding: 16px;
  display: flex;
  gap: 16.3px;
  background-color: #fff;
}
.planning .step.results .goal__input-area .date-picker {
  position: relative !important;
}
.planning .step.results .goal img {
  align-self: flex-start;
  padding-top: 2px;
}
.planning .step.results .goal p {
  padding-bottom: 16px;
}
.planning .step.results .technical-notes p {
  cursor: pointer;
  max-width: 196px;
  text-decoration: underline;
  color: var(--sebrae-dark-gray2);
}
.planning .step.results .technical-notes p:hover {
  color: #000;
}
.planning .step.results .technical-notes p:hover p {
  color: #000;
}
.planning .step.results .form .chart-area .wrapper-select {
  display: flex;
  align-items: center;
  gap: 15px;
}
.planning .step.results .form .chart-area .wrapper-select .btn-clear {
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 23.3px;
  background-color: var(--sebrae-blue);
  color: var(--sebrae-white);
  padding: 5px 10px;
  border-radius: 5px;
  margin-top: 12px;
  width: 100px;
}
.planning .step.results .form .chart-area__data {
  padding: 30px 0;
}
.planning .step.results .form .chart-area div[width="286"] {
  z-index: 2;
}
.planning .step.results .form .chart-area div input {
  width: 100%;
}
.planning .step.results .form .submit-and-download {
  display: flex;
  justify-content: center;
  padding: 24px 20px;
}
.planning .step.results .form .BaSe--input-input {
  border-color: var(--sebrae-light-gray5) !important;
}
.planning .step.results .form textarea {
  min-height: 148px;
}
.planning .step.results .finish-and-download {
  display: flex;
}
@media screen and (min-width: 768px) {
  .planning .step.results {
    padding-bottom: 40px;
    max-width: max-content;
  }
  .planning .step.results .technical-notes {
    display: flex;
    justify-content: center;
  }
  .planning .step.results .technical-notes p {
    text-align: center;
  }
  .planning .step.results .chart-area .wrapper-select {
    max-width: 100%;
  }
  .planning .step.results .chart-area .wrapper-select .BaSe--input {
    max-width: 100%;
  }
  .planning .step.results .chart-area .wrapper-select .BaSe--select {
    width: 100%;
  }
  .planning .step.results .accordion-content-internal {
    display: flex;
    padding: 0 60px;
    margin-bottom: 24px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .planning .step.results .accordion-content-internal .first-block {
    padding-right: 58px;
  }
  .planning .step.results .accordion-content-internal .first-block p {
    font-size: 16px;
  }
  .planning .step.results .sections-bar.without-bottom {
    margin: 0;
    margin-top: 16px;
  }
  .planning .step.results .sections-bar.mobile {
    display: none;
  }
  .planning .step.results .results-space {
    padding-top: 32px;
  }
  .planning .step.results .inputs-area {
    gap: 23px;
    display: flex;
    justify-content: space-between;
  }
  .planning .step.results .inputs-area div {
    flex: 1 1;
  }
  .planning .step.results .inputs-area div .BaSe--input {
    max-width: 100%;
  }
}
@media screen and (min-width: 768px) and (min-width: 769px) {
  .planning .step.results .inputs-area div .BaSe--input-label {
    font-size: 1.85vw !important;
    line-height: 1.2;
  }
}
@media screen and (min-width: 768px) and (min-width: 992px) {
  .planning .step.results .inputs-area div .BaSe--input-label {
    font-size: 1.4vw !important;
  }
}
@media screen and (min-width: 768px) and (min-width: 1024px) {
  .planning .step.results .inputs-area div .BaSe--input-label {
    font-size: 16px !important;
  }
}
@media screen and (min-width: 768px) and (min-width: 769px) {
  .planning .step.results .inputs-area div .input-textarea-label {
    font-size: 1.85vw !important;
    line-height: 1.2;
  }
}
@media screen and (min-width: 768px) and (min-width: 992px) {
  .planning .step.results .inputs-area div .input-textarea-label {
    font-size: 1.4vw !important;
  }
}
@media screen and (min-width: 768px) and (min-width: 1024px) {
  .planning .step.results .inputs-area div .input-textarea-label {
    font-size: 16px !important;
  }
}
@media screen and (min-width: 768px) {
  .planning .step.results .title-result {
    font-size: 16px;
  }
  .planning .step.results .title-result.mobile {
    display: none;
  }
  .planning .step.results .results-information__info .tooltip-capital {
    align-self: normal;
    padding-top: 10.5px;
  }
  .planning .step.results .form .submit-and-download {
    display: none;
  }
  .planning .step.results .form .technical-notes {
    padding: 24px 0;
  }
}
@media (min-width: 970px) and (max-width: 1023px) {
  .planning .step.results .results-information__info .tooltip-capital {
    padding: 0;
    align-self: center;
  }
}
@media screen and (min-width: 992px) {
  .planning .step.results .results-information {
    padding-bottom: 0;
  }
  .planning .step.results .results-information__info {
    width: 48%;
  }
  .planning .step.results .results-information__value {
    width: 52%;
    text-align: center;
    letter-spacing: -0.7px;
  }
  .planning .step.results .form .goal {
    justify-content: flex-start;
  }
}
@media screen and (min-width: 1024px) {
  .planning .step.results .results-and-calculations {
    gap: 24px;
    flex-direction: row;
  }
  .planning .step.results .results-and-calculations.special-result {
    margin-bottom: 16px;
  }
  .planning .step.results .results-and-calculations .results-information {
    flex: 1 1;
  }
  .planning .step.results .results-and-calculations .results-information__value.highlighted {
    font-size: 19px;
  }
  .planning .step.results .results-and-calculations .results-information__value.big-number {
    font-size: 11px;
  }
  .planning .step.results .form .chart-area__data {
    padding: 30px 0;
  }
}
@media screen and (min-width: 1280px) {
  .planning .step.results .results-information__info {
    width: 55%;
  }
  .planning .step.results .results-information__value {
    width: 45%;
    letter-spacing: normal;
  }
}
.planning .business-accordion {
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
  border-radius: 8px;
  overflow: hidden;
  background-color: #ebe8ff;
}
.planning .business-accordion .custom-accordion-header {
  cursor: pointer;
  padding: 24px 24px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  transition: background-color 0.3s ease;
}
.planning .business-accordion .custom-accordion-header .custom-accordion-title {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}
.planning .business-accordion .custom-accordion-header .custom-accordion-title span {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: var(--sebrae-blue-2);
}
@media (max-width: 880px) {
  .planning .business-accordion .custom-accordion-header .custom-accordion-title {
    gap: 6px;
  }
  .planning .business-accordion .custom-accordion-header .custom-accordion-title img {
    width: 24px;
    height: 24px;
  }
  .planning .business-accordion .custom-accordion-header .custom-accordion-title span {
    font-size: 15px;
    line-height: 19px;
  }
}
.planning .business-accordion .custom-accordion-header .custom-accordion-arrow {
  border: 1px solid #617385;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.planning .business-accordion .custom-accordion-header .custom-accordion-arrow figure {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 880px) {
  .planning .business-accordion .custom-accordion-header .custom-accordion-arrow figure img {
    width: 18px;
    height: 18px;
  }
}
@media (max-width: 880px) {
  .planning .business-accordion .custom-accordion-header {
    padding: 24px 12px 16px;
    gap: 8px;
  }
}
.planning .business-accordion .custom-accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.25s ease-in-out, padding 0.25s ease-in-out;
}
.planning .business-accordion .custom-accordion-content.active {
  max-height: 1000px;
  padding: 0 24px 24px;
}
@media (max-width: 880px) {
  .planning .business-accordion .custom-accordion-content.active {
    padding: 0 12px 24px;
  }
}
.planning .business-accordion .accordion-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.planning .business-accordion .accordion-content-left, .planning .business-accordion .accordion-content-right {
  height: fit-content;
  word-break: normal;
}
.planning .business-accordion .accordion-content-left p {
  font-size: 16px;
  font-weight: 400;
  line-height: 23.3px;
  margin-bottom: 4px;
}
.planning .business-accordion .accordion-content-left .accordion-checkboxes {
  display: flex;
  gap: 16px;
}
.planning .business-accordion .accordion-content-left .accordion-checkboxes div[shape=square] {
  width: 18px;
  height: 18px;
}
.planning .business-accordion .accordion-content-right .input-wrapper {
  display: flex;
  align-items: center;
}
.planning .business-accordion .accordion-content-right .input-wrapper .wrapper-input {
  flex: 1 1;
}
.planning .business-accordion .accordion-content-right .input-wrapper input:disabled {
  cursor: not-allowed;
}
.planning .business-accordion .accordion-content-right .input-wrapper .BaSe--checkbox div[shape=circle] {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}
.planning .business-accordion .accordion-content-right .button-wrapper {
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 555px) {
  .planning .business-accordion .accordion-content {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .planning .business-accordion {
    margin-top: 12px;
  }
}
.planning .projected-flow {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  background-color: #fff;
  border: 1px dashed #40bbff;
  border-radius: 4px;
  margin-top: 2px;
  text-align: center;
}
.planning .projected-flow p {
  font-size: 13px;
  padding-bottom: 16px;
}
.planning .projected-flow .BaSe--button {
  margin: 0 auto !important;
}
.planning .modal-default.dialog-exists .BaSe--input {
  max-width: 100%;
}
.planning .modal-default.dialog-exists form {
  max-width: 424px;
  margin: 0 auto;
}
.planning .modal-default.dialog-alert-ncg .wrapper-modal .title {
  font-size: 16px;
}
@media screen and (min-width: 768px) {
  .planning .modal-default.dialog-alert-ncg .wrapper-modal .title {
    font-size: 19px;
  }
}
.planning .modal-default.dialog-alert-ncg .dialog-alert__description {
  font-size: 13px;
}
.planning .modal-default.dialog-alert-ncg .dialog-alert__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
  flex-wrap: wrap;
}
.planning .modal-default.dialog-alert-ncg .dialog-alert__buttons button {
  min-height: 32px;
  padding: 5px 12px;
  flex: 1 1;
}
.planning .modal-default.dialog-alert-ncg .dialog-alert__buttons button:last-of-type {
  flex: auto;
}
.planning .modal-default.dialog-alert-ncg .dialog-alert__buttons span {
  font-size: 13px;
}
@media screen and (min-width: 768px) {
  .planning .modal-default.dialog-alert-ncg .dialog-alert__buttons {
    flex-wrap: nowrap;
    gap: 12px;
  }
  .planning .modal-default.dialog-alert-ncg .dialog-alert__buttons button {
    flex: none !important;
  }
}
.planning .modal-default.dialog-alert-ncg .dialog-alert__checkbox {
  margin-top: 24px;
}
.planning .modal-default.dialog-alert-ncg .dialog-alert__checkbox .BaSe--checkbox > div input {
  width: 16px;
  height: 16px;
  margin: 0;
}
.planning .modal-default.dialog-alert-ncg .dialog-alert__checkbox .BaSe--checkbox > div div {
  width: 16px;
  height: 16px;
  border: 1px solid var(--sebrae-blue-2);
}
.planning .modal-default.dialog-alert-ncg .dialog-alert__checkbox .BaSe--checkbox label {
  font-size: 13px;
  line-height: 1.2;
  color: var(--sebrae-gray);
}
.planning .modal-default.dialog-alert .title {
  font-size: 16px;
}
.planning .modal-default.dialog-alert .dialog-alert__description {
  font-size: 13px;
}
.planning .modal-default.dialog-alert .dialog-alert__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-top: 24px;
}
.planning .modal-default.dialog-alert .dialog-alert__buttons button {
  min-height: 32px;
  padding: 5px 12px;
}
.planning .modal-default.dialog-alert .dialog-alert__buttons span {
  font-size: 13px;
}
.planning .modal-default.dialog-alert .dialog-alert__checkbox {
  margin-top: 24px;
}
.planning .modal-default.dialog-alert .dialog-alert__checkbox .BaSe--checkbox > div input {
  width: 16px;
  height: 16px;
  margin: 0;
}
.planning .modal-default.dialog-alert .dialog-alert__checkbox .BaSe--checkbox > div div {
  width: 16px;
  height: 16px;
  border: 1px solid var(--sebrae-blue-2);
}
.planning .modal-default.dialog-alert .dialog-alert__checkbox .BaSe--checkbox label {
  font-size: 13px;
  line-height: 1.2;
  color: var(--sebrae-gray);
}
.planning .modal-default.dialog-alert.zero .dialog-alert__buttons {
  gap: 16px;
}
.planning .modal-default.dialog-alert.zero .dialog-alert__buttons button {
  min-width: 137px;
}
.planning .modal-default.dialog-prompt .dialog-prompt__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-top: 24px;
}
@media screen and (min-width: 768px) {
  .planning .modal-default.add-initial-balance .wrapper-modal {
    max-width: 407px;
  }
  .planning .modal-default.dialog-exists .wrapper-modal {
    max-width: 488px;
  }
  .planning .modal-default.dialog-alert .wrapper-modal {
    max-width: 405px;
  }
  .planning .modal-default.dialog-alert.zero .wrapper-modal {
    max-width: 343px;
  }
  .planning .modal-default.dialog-prompt .wrapper-modal {
    max-width: 410px;
  }
}
@media screen and (min-width: 1024px) {
  .planning .modal-default .modal-body {
    padding: 8px;
  }
  .planning .modal-default.finish .title {
    font-size: 23px;
  }
  .planning .modal-default.finish .dialog-alert__description {
    font-size: 16px;
  }
  .planning .modal-default.finish .dialog-alert__buttons button {
    min-height: 40px;
    min-width: 113px;
  }
  .planning .modal-default.finish .dialog-alert__buttons button span {
    font-size: 16px;
  }
}
@media screen and (min-width: 768px) {
  .planning__content {
    flex-direction: row;
    min-height: 83dvh;
  }
  .planning__content--left {
    position: relative;
    padding: 24px 20px 0 24px;
    width: 295px;
    text-align: right;
    background: var(--sebrae-white-3);
  }
  .planning__content--right {
    width: calc(100% - 295px);
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
  .planning__wrapper--left {
    position: sticky;
    top: 84px;
    display: inline-block;
  }
  .planning__wrapper--right {
    width: 100%;
    max-width: 1120px;
    padding: 12px 20px 56px;
  }
  .planning__breadcrumb {
    display: block;
  }
  .planning__step {
    border-radius: 8px;
    border: 1px solid var(--sebrae-light-gray4);
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
    padding: 16px;
  }
  .planning__step--title {
    display: flex;
  }
  .planning__step--title span {
    font-size: 16px;
  }
  .planning__footer {
    top: 56px;
    bottom: auto;
    max-width: 1120px;
    padding: 24px 20px 12px;
  }
  .planning__footer button {
    flex: none;
  }
  .planning__footer .BaSe--button {
    box-shadow: none;
  }
}
@media screen and (min-width: 1200px) {
  .planning__footer {
    top: 60px;
  }
}
@media screen and (min-width: 1280px) {
  .planning__wrapper--right {
    padding: 12px 40px 56px;
  }
  .planning__step {
    padding: 32px;
  }
  .planning__footer {
    padding: 24px 40px 12px;
  }
  .planning .step--info {
    border: none;
  }
  .planning .step--subtitle.icon {
    align-items: center;
  }
  .planning .step.variable-indirect-costs .BaSe--grid, .planning .step.monthly-average .BaSe--grid, .planning .step.total-investment .BaSe--grid {
    row-gap: 10px !important;
    column-gap: 33px !important;
  }
  .planning .step.variable-indirect-costs .step--info, .planning .step.total-investment .step--info, .planning .step.receipt-deadline .step--info, .planning .step.payment-terms .step--info, .planning .step.inventory-turnover .step--info {
    margin-bottom: 0;
  }
  .planning .step.monthly-average .step--info {
    padding-bottom: 0;
  }
  .planning .step .inventory-turnover__wrapper {
    width: 100%;
    max-width: 480px;
  }
}
@media screen and (min-width: 1440px) {
  .planning__content {
    min-height: 88dvh;
  }
  .planning__content--left {
    width: 20.5vw;
  }
  .planning__content--right {
    width: 100%;
  }
}
@media screen and (min-width: 1910px) {
  .planning__content--left {
    width: 28vw;
  }
}
@media screen and (min-width: 1921px) {
  .planning__content--left {
    width: 28vw;
  }
  .planning__wrapper--right, .planning__footer {
    max-width: 58vw;
  }
}
@media screen and (min-width: 2550px) {
  .planning__content--left {
    width: 34vw;
  }
  .planning__wrapper--right, .planning__footer {
    max-width: 43.5vw;
  }
}
@media screen and (min-width: 3830px) {
  .planning__content--left {
    width: 39.4vw;
  }
  .planning__wrapper--right, .planning__footer {
    max-width: 29vw;
  }
}

.btn-solution {
  background-image: linear-gradient(35deg, #cd5be8 0%, #ffabab 100%);
  width: 100%;
  padding: 8px 16px;
  display: flex;
  font-family: Campuni;
  font-weight: bold;
  font-size: 12px;
  color: var(--sebrae-light-gray);
  box-shadow: 0px 4px 8px 0px rgba(20, 46, 82, 0.2);
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.btn-solution .wrapper-icon {
  position: relative;
  width: 20px;
  height: 20px;
}
.btn-solution .wrapper-icon img {
  width: 100%;
  height: 100%;
}
.btn-solution .wrapper-icon .notification {
  position: absolute;
  top: 12%;
  left: 90%;
  transform: translate(-50%, -50%);
  background-color: #db340b;
  width: 14px;
  height: 14px;
  border-radius: 50px;
  font-family: Lato;
  font-size: 8px;
  font-weight: bold;
  color: var(--sebrae-white);
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 768px) {
  .btn-solution {
    margin-block: 24px;
    border-radius: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/planning/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;AAAJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,+BAAA;AAAJ;AAEI;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;EACA,sBAAA;AAAN;AAGE;EACE,WAAA;EACA,kBAAA;AADJ;AAGE;EACE,WAAA;AADJ;AAGI;EACE,aAAA;EAEE,eAAA;EACA,gBAAA;EAEF,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AAHN;AAKM;EAEI,eAAA;EACA,gBAAA;AAJV;AASE;EACE,gBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,qCAAA;AAPJ;AASI;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;AAPN;AASM;EACE,aAAA;EACA,SAAA;AAPR;AASQ;EAJF;IAKI,YAAA;IACA,gBAAA;EANR;AACF;AAQQ;EATF;IAUI,YAAA;IACA,gBAAA;EALR;AACF;AAQM;EApBF;IAqBI,6BAAA;EALN;AACF;AAOM;EAxBF;IAyBI,WAAA;IACA,8BAAA;EAJN;AACF;AAOI;EACE,UAAA;AALN;AAQI;EACE,YAAA;EACA,uCAAA;EACA,yBAAA;EACA,2BAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AANN;AAQM;EACE,aAAA;AANR;AAUI;EACE,SAAA;AARN;AAUM;EACE,WAAA;EACA,YAAA;AARR;AAYI;EAxEF;IAyEI,sBAAA;IACA,uBAAA;EATJ;AACF;AAYI;EACE,oBAAA;EACA,kDAAA;EACA,mBAAA;AAVN;AAYI;EAEE,yBAAA;AAXN;AAaI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAXN;AAaI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAXN;AAaM;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AAXR;AAcI;EACE,oBAAA;AAZN;AAcI;EACE,eAAA;EACA,wBAAA;AAZN;AAcM;EAJF;IAKI,eAAA;EAXN;AACF;AAgBM;EACE,iBAAA;AAdR;AAgBQ;EACE,oBAAA;AAdV;AAmBM;EACE,iBAAA;AAjBR;AAyBM;EACE,mBAAA;AAvBR;AAyBM;EACE,mBAAA;AAvBR;AA4BY;EACE,iBAAA;AA1Bd;AAkCM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;EAEE,eAAA;EACA,gBAAA;AAjCV;AAsCU;EACE,SAAA;AApCZ;AAsCY;EACE,kBAAA;EACA,gBAAA;AApCd;AAsCY;EACE,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,gCAAA;EACA,mFAAA;AApCd;AA6CU;EACE,SAAA;AA3CZ;AA6CY;EACE,kBAAA;EACA,gBAAA;AA3Cd;AA8CY;EACE,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,gCAAA;EACA,mFAAA;AA5Cd;AAqDM;EACE,gBAAA;EACA,qBAAA;AAnDR;AAuDM;;;EAGE,SAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AArDR;AAuDM;EACE,mBAAA;AArDR;AAuDQ;EACE,SAAA;AArDV;AAyDQ;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAvDV;AA0DM;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;EACA,4CAAA;AAxDR;AA0DQ;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;AAxDV;AA2DQ;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;AAzDV;AA4DQ;EACE,uCAAA;EACA,4CAAA;AA1DV;AA4DU;;EAEE,gCAAA;AA1DZ;AA8DQ;EACE,qBAAA;EACA,sBAAA;AA5DV;AA8DU;;;EAGE,cAAA;AA5DZ;AAgEQ;EACE,qBAAA;EACA,yBAAA;AA9DV;AAgEU;;EAEE,cAAA;AA9DZ;AAoEQ;EACE,QAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,2CAAA;EACA,6CAAA;AAlEV;AAoEU;EACE,YAAA;EACA,oBAAA;EACA,2CAAA;AAlEZ;AAoEU;EACE,WAAA;EACA,mBAAA;AAlEZ;AAqEU;EACE,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAnEZ;AAsEQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AApEV;AAsEU;EANF;IAOI,mBAAA;EAnEV;AACF;AAqEU;EACE,aAAA;AAnEZ;AAsEU;EACE,SAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,2CAAA;EACA,6CAAA;AApEZ;AAsEY;EACE,QAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AApEd;AAsEc;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AApEhB;AAyEU;EACE,WAAA;EACA,mBAAA;AAvEZ;AA0EU;EACE,YAAA;EACA,oBAAA;EACA,2CAAA;AAxEZ;AA0EY;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAxEd;AA6EM;EACE,QAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;AA3ER;AA6EQ;EACE,gBAAA;AA3EV;AA8EQ;EACE,eAAA;AA5EV;AA+EM;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AA7ER;AA+EQ;EANF;IAOI,mBAAA;EA5ER;EA+EU;IACE,gBAAA;EA7EZ;AACF;AAiFM;EACE,gBAAA;AA/ER;AAiFQ;EACE,SAAA;EACA,aAAA;EACA,gBAAA;AA/EV;AAkFM;EACE,2BAAA;EAEE,oBAAA;EACA,eAAA;EACA,gBAAA;EAEF,kBAAA;AAlFR;AAoFM;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAlFR;AAoFM;EACE,gBAAA;AAlFR;AAoFQ;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAlFV;AAoFQ;EACE,kBAAA;EACA,2CAAA;EACA,iCAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlFV;AAqFU;EACE,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAnFZ;AAsFQ;EACE,kBAAA;EACA,4DAAA;EACA,6CAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AApFV;AAuFU;EACE,+BAAA;EACA,yBAAA;AArFZ;AAuFU;EACE,4DAAA;AArFZ;AA0FY;EACE,kBAAA;AAxFd;AA0Fc;EACE,gBAAA;AAxFhB;AA2Fc;EACE,gBAAA;AAzFhB;AA6FU;EACE,uBAAA;EACA,gBAAA;AA3FZ;AA4FY;EACE,kBAAA;AA1Fd;AA6FU;EACE,WAAA;AA3FZ;AA+FU;EACE,gBAAA;EACA,kBAAA;AA7FZ;AA+FY;EACE,mBAAA;AA7Fd;AA+FY;EACE,mBAAA;AA7Fd;AA+FY;EACE,UAAA;AA7Fd;AAgGY;EACE,eAAA;EACA,gBAAA;AA9Fd;AAkGQ;EACE,kBAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAhGV;AAmGU;EACE,qCAAA;EACA,yBAAA;AAjGZ;AAmGY;EACE,2CAAA;EACA,2BAAA;AAjGd;AAqGU;EACE,QAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAnGZ;AAqGY;EACE,eAAA;AAnGd;AAsGY;EACE,2BAAA;AApGd;AAuGY;EACE,8BAAA;AArGd;AAwGY;EACE,WAAA;AAtGd;AAyGY;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAvGd;AA0GU;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AAxGZ;AA0GY;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAxGd;AA4Gc;EACE,UAAA;AA1GhB;AA8GY;EACE,SAAA;EACA,aAAA;EACA,mBAAA;AA5Gd;AA+GgB;EACE,8BAAA;EACA,YAAA;EACA,oBAAA;AA7GlB;AAmHU;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;AAjHZ;AAmHY;EACE,UAAA;AAjHd;AAqHU;EACE,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnHZ;AAsHU;EACE,iBAAA;EACA,kBAAA;EACA,2BAAA;AApHZ;AAsHU;EACE,sBAAA;AApHZ;AAsHY;EACE,iBAAA;AApHd;AAuHY;EACE,2BAAA;AArHd;AAwHY;EACE,QAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAtHd;AAwHc;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AAtHhB;AA0HgB;EACE,eAAA;AAxHlB;AA4HY;EACE,WAAA;EACA,eAAA;AA1Hd;AA4HY;EACE,UAAA;EACA,eAAA;EAEE,eAAA;EAEF,gBAAA;EACA,+BAAA;AA5Hd;AA+HY;EACE,iBAAA;AA7Hd;AA+HY;EACE,gBAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AA7Hd;AA+Hc;EACE,8BAAA;AA7HhB;AAgIc;EACE,8BAAA;AA9HhB;AAmIQ;EACE,eAAA;AAjIV;AAqIY;EACE,kBAAA;AAnId;AAqIc;EACE,QAAA;EACA,aAAA;EACA,mBAAA;AAnIhB;AA0IQ;EACE,0BAAA;AAxIV;AA0IQ;EACE,wBAAA;AAxIV;AA0IQ;EACE,0BAAA;AAxIV;AA0IU;EACE,YAAA;AAxIZ;AA6IY;EACE,kBAAA;AA3Id;AA+IU;EACE,kBAAA;EACA,SAAA;AA7IZ;AA+IY;EACE,WAAA;EACA,YAAA;AA7Id;AA8Ic;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AA5IhB;AA8IgB;EACE,aAAA;AA5IlB;AAgJgB;EACE,uBAAA;EACA,WAAA;AA9IlB;AAoJU;EACE;IACE,iBAAA;EAlJZ;AACF;AAqJQ;EACE,kBAAA;EACA,YAAA;EACA,oBAAA;AAnJV;AAqJU;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;AAnJZ;AAuJU;EACE,eAAA;AArJZ;AAuJY;EACE,WAAA;AArJd;AA0JM;EACE,eAAA;EACA,+CAAA;EACA,gBAAA;AAxJR;AA4JU;EACE,gBAAA;AA1JZ;AA2JY;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAzJd;AA4JU;EACE,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA1JZ;AA+JU;EACE,gBAAA;EACA,oBAAA;AA7JZ;AAgKU;EACE,cAAA;EACA,mBAAA;AA9JZ;AAiKU;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA/JZ;AAoKQ;EACE,iBAAA;AAlKV;AAoKQ;EACE,aAAA;EACA,SAAA;AAlKV;AAoKU;EACE,WAAA;AAlKZ;AAsKU;EACE,aAAA;EACA,SAAA;AApKZ;AA0KU;EACE,wCAAA;EACA,WAAA;EACA,YAAA;AAxKZ;AA4KM;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA1KR;AA4KM;EACE,oBAAA;EACA,iBAAA;AA1KR;AA4KQ;EACE,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AA1KV;AA8KQ;EACE,YAAA;EACA,eAAA;AA5KV;AA+KM;EACE,kBAAA;EACA,gBAAA;AA7KR;AAgLU;EACE,kBAAA;AA9KZ;AAgLU;EACE,iBAAA;AA9KZ;AAgLU;EACE,2BAAA;EACA,eAAA;AA9KZ;AAiLQ;EACE,aAAA;AA/KV;AAiLU;EAEI,eAAA;EACA,gBAAA;EAEF,mBAAA;EACA,2BAAA;AAjLZ;AAmLU;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAjLZ;AAmLY;EACE,YAAA;EACA,YAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EAEE,eAAA;EACA,gBAAA;EAEF,yBAAA;EACA,uBAAA;EACA,kDAAA;AAnLd;AAqLc;EACE,sCAAA;EACA,kCAAA;EACA,0BAAA;EACA,gBAAA;AAnLhB;AA0LM;EAEI;IACE,eAAA;EAzLV;AACF;AA4LM;EAEI;IACE,gBAAA;IACA,YAAA;EA3LV;EA8LM;IACE,gBAAA;IACA,YAAA;EA5LR;EAkMgB;IACE,yBAAA;EAhMlB;EAoMc;IACE,yBAAA;EAlMhB;EAwMQ;IACE,kDAAA;IACA,mBAAA;EAtMV;EAwMU;IACE,oCAAA;IACA,mBAAA;EAtMZ;EA0MM;IACE,iBAAA;IAGA,WAAA;EA1MR;EA6MQ;;IAEE,gBAAA;EA3MV;EA8MU;;IAEE,SAAA;EA5MZ;AACF;AAiNM;EAEI;IACE,kBAAA;EAhNV;AACF;AAmNM;EACE;IACE,aAAA;IACA,sBAAA;IACA,8BAAA;IACA,SAAA;EAjNR;EAmNM;IACE,gBAAA;IACA,qBAAA;IACA,oCAAA;EAjNR;EAoNQ;IACE,mBAAA;EAlNV;EAoNQ;IACE,sBAAA;IACA,oBAAA;EAlNV;EAsNQ;IACE,cAAA;EApNV;EAsNQ;IACE,aAAA;EApNV;EAuNM;IACE,iBAAA;EArNR;AACF;AAuNM;EACE;IACE,iBAAA;IACA,iBAAA;EArNR;EAuNM;IACE,gBAAA;EArNR;EAwNQ;IACE,iBAAA;EAtNV;EAwNQ;IACE,aAAA;IACA,gBAAA;EAtNV;AACF;AA0NI;EACE,0BAAA;AAxNN;AA0NM;EACE,oBAAA;AAxNR;AA0NQ;EACE,eAAA;AAxNV;AA4NM;EACE,eAAA;EACA,oBAAA;AA1NR;AA6NM;EACE,oBAAA;AA3NR;AA6NQ;EACE,SAAA;AA3NV;AA6NU;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AA3NZ;AA8NU;EACE,eAAA;EACA,gBAAA;AA5NZ;AA+NU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AA7NZ;AAiOQ;EACE,SAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AA/NV;AAiOU;EACE,eAAA;AA/NZ;AAkOU;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;AAhOZ;AAkOY;EACE,gBAAA;AAhOd;AAoOU;EACE,UAAA;EACA,aAAA;EACA,mBAAA;AAlOZ;AAoOY;EACE,WAAA;EACA,YAAA;AAlOd;AAwOM;EACE,mBAAA;EACA,gCAAA;AAtOR;AAwOQ;EACE,gBAAA;EACA,cAAA;AAtOV;AAyOQ;EACE,gBAAA;AAvOV;AA0OQ;EACE,kDAAA;AAxOV;AA2OQ;EACE,SAAA;EACA,mBAAA;AAzOV;AA4OQ;EACE,gBAAA;EACA,cAAA;AA1OV;AA8OM;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AA5OR;AA8OQ;EACE,iBAAA;AA5OV;AA+OM;EACE,QAAA;EACA,aAAA;EACA,sBAAA;AA7OR;AA+OQ;EACE,mBAAA;AA7OV;AAgPQ;EACE,SAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AA9OV;AAoPU;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AAlPZ;AAoPY;EACE,eAAA;AAlPd;AAqPY;EACE,WAAA;EACA,YAAA;AAnPd;AAuPU;EACE,oBAAA;AArPZ;AAuPY;EACE,gBAAA;AArPd;AAwPY;;EAEE,eAAA;AAtPd;AAyPY;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAvPd;AA6PM;EACE,kBAAA;EAEA,sBAAA;EACA,2CAAA;AA5PR;AA+PQ;EACE,aAAA;EAEA,sBAAA;EACA,8BAAA;AA9PV;AAiQQ;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;EAEA,8BAAA;EACA,gBAAA;EACA,kDAAA;EACA,2BAAA;AAhQV;AAkQU;EACE,SAAA;EACA,uBAAA;AAhQZ;AAoQQ;EACE,UAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AAlQV;AAqQQ;EACE,UAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AAnQV;AAqQU;EACE,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,cAAA;AAnQZ;AAsQU;EACE,eAAA;AApQZ;AAwQM;EACE,eAAA;AAtQR;AAwQQ;EACE,eAAA;EACA,gBAAA;AAtQV;AA0QQ;EACE,eAAA;EACA,gBAAA;AAxQV;AA4QM;EACE,kDAAA;EACA,cAAA;AA1QR;AA4QQ;EACE,mBAAA;AA1QV;AA6QM;EACE,mBAAA;AA3QR;AA6QQ;EACE,UAAA;EACA,oBAAA;AA3QV;AA8QM;EACE,aAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AA5QR;AA+QU;EACE,6BAAA;AA7QZ;AAiRQ;EACE,sBAAA;EACA,gBAAA;AA/QV;AAkRQ;EACE,oBAAA;AAhRV;AAqRQ;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,+BAAA;AAnRV;AAqRU;EACE,WAAA;AAnRZ;AAoRY;EACE,WAAA;AAlRd;AA0RU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAxRZ;AA0RY;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAxRd;AA2RU;EACE,eAAA;AAzRZ;AA4RU;EACE,UAAA;AA1RZ;AA8RY;EACE,WAAA;AA5Rd;AAgSQ;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AA9RV;AAiSQ;EACE,kDAAA;AA/RV;AAiSQ;EACE,iBAAA;AA/RV;AAkSM;EACE,aAAA;AAhSR;AAmSM;EAhWF;IAiWI,oBAAA;IACA,sBAAA;EAhSN;EAkSM;IACE,aAAA;IACA,uBAAA;EAhSR;EAkSQ;IACE,kBAAA;EAhSV;EAqSQ;IACE,eAAA;EAnSV;EAqSU;IACE,eAAA;EAnSZ;EAsSU;IACE,WAAA;EApSZ;EAySM;IACE,aAAA;IACA,eAAA;IACA,mBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;EAvSR;EAySQ;IACE,mBAAA;EAvSV;EAySU;IACE,eAAA;EAvSZ;EA6SQ;IACE,SAAA;IACA,gBAAA;EA3SV;EA8SQ;IACE,aAAA;EA5SV;EAgTM;IACE,iBAAA;EA9SR;EAiTM;IACE,SAAA;IACA,aAAA;IACA,8BAAA;EA/SR;EAiTQ;IACE,SAAA;EA/SV;EAiTU;IACE,eAAA;EA/SZ;AACF;AAgTc;EACE;IACE,4BAAA;IACA,gBAAA;EA9ShB;AACF;AAgTc;EACE;IACE,2BAAA;EA9ShB;AACF;AAgTc;EACE;IACE,0BAAA;EA9ShB;AACF;AAkTc;EACE;IACE,4BAAA;IACA,gBAAA;EAhThB;AACF;AAkTc;EACE;IACE,2BAAA;EAhThB;AACF;AAkTc;EACE;IACE,0BAAA;EAhThB;AACF;AA0MM;EA4GE;IACE,eAAA;EAnTR;EAqTQ;IACE,aAAA;EAnTV;EAyTU;IACE,kBAAA;IACA,mBAAA;EAvTZ;EA6TQ;IACE,aAAA;EA3TV;EA8TQ;IACE,eAAA;EA5TV;AACF;AA+TM;EAGM;IACE,UAAA;IACA,kBAAA;EA/TZ;AACF;AAoUM;EACE;IACE,iBAAA;EAlUR;EAoUQ;IACE,UAAA;EAlUV;EAqUQ;IACE,UAAA;IACA,kBAAA;IACA,sBAAA;EAnUV;EAwUQ;IACE,2BAAA;EAtUV;AACF;AAyUM;EACE;IACE,SAAA;IACA,mBAAA;EAvUR;EAyUQ;IACE,mBAAA;EAvUV;EA0UQ;IACE,SAAA;EAxUV;EA2UY;IACE,eAAA;EAzUd;EA4UY;IACE,eAAA;EA1Ud;EAkVU;IACE,eAAA;EAhVZ;AACF;AAoVM;EAEI;IACE,UAAA;EAnVV;EAqVQ;IACE,UAAA;IACA,sBAAA;EAnVV;AACF;AAyVE;EACE,6CAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAvVJ;AAyVI;EACE,eAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,sCAAA;AAvVN;AAyVM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;AAvVR;AAyVQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAvVV;AA0VQ;EAbF;IAcI,QAAA;EAvVR;EAwVQ;IACE,WAAA;IACA,YAAA;EAtVV;EAwVQ;IACE,eAAA;IACA,iBAAA;EAtVV;AACF;AA0VM;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAxVR;AA0VQ;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxVV;AA0VU;EACE;IACE,WAAA;IACA,YAAA;EAxVZ;AACF;AA6VM;EA1DF;IA2DI,uBAAA;IACA,QAAA;EA1VN;AACF;AA6VI;EACE,aAAA;EACA,gBAAA;EACA,mEAAA;AA3VN;AA6VM;EACE,kBAAA;EACA,oBAAA;AA3VR;AA6VQ;EAJF;IAKI,oBAAA;EA1VR;AACF;AA8VI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AA5VN;AA8VM;EAEE,mBAAA;EACA,kBAAA;AA7VR;AAiWQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AA/VV;AAkWQ;EACE,aAAA;EACA,SAAA;AAhWV;AAkWU;EACE,WAAA;EACA,YAAA;AAhWZ;AAsWQ;EACE,aAAA;EACA,mBAAA;AApWV;AAsWU;EACE,SAAA;AApWZ;AAuWU;EACE,mBAAA;AArWZ;AAyWY;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAvWd;AA4WQ;EACE,aAAA;EACA,yBAAA;AA1WV;AA8WM;EA1DF;IA2DI,0BAAA;EA3WN;AACF;AA8WI;EApJF;IAqJI,gBAAA;EA3WJ;AACF;AA8WE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AA5WJ;AA8WI;EACE,eAAA;EACA,oBAAA;AA5WN;AA8WI;EACE,yBAAA;AA5WN;AAiXM;EACE,eAAA;AA/WR;AAiXM;EACE,gBAAA;EACA,cAAA;AA/WR;AAqXU;EACE,eAAA;AAnXZ;AAqXY;EAHF;IAII,eAAA;EAlXZ;AACF;AAuXU;EACE,eAAA;AArXZ;AAuXU;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AArXZ;AAuXY;EACE,gBAAA;EACA,iBAAA;EACA,SAAA;AArXd;AAuXc;EACE,UAAA;AArXhB;AAwXY;EACE,eAAA;AAtXd;AAyXY;EApBF;IAqBI,iBAAA;IACA,SAAA;EAtXZ;EAwXY;IACE,qBAAA;EAtXd;AACF;AAyXU;EACE,gBAAA;AAvXZ;AA0XgB;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAxXlB;AA0XgB;EACE,WAAA;EACA,YAAA;EACA,sCAAA;AAxXlB;AA2Xc;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AAzXhB;AAgYM;EACE,eAAA;AA9XR;AAiYQ;EACE,eAAA;AA/XV;AAiYQ;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AA/XV;AAiYU;EACE,gBAAA;EACA,iBAAA;AA/XZ;AAiYU;EACE,eAAA;AA/XZ;AAkYQ;EACE,gBAAA;AAhYV;AAmYc;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAjYhB;AAmYc;EACE,WAAA;EACA,YAAA;EACA,sCAAA;AAjYhB;AAoYY;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AAlYd;AAyYQ;EACE,SAAA;AAvYV;AAyYU;EACE,gBAAA;AAvYZ;AA6YM;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AA3YR;AA+YI;EAEI;IACE,gBAAA;EA9YR;EAkZM;IACE,gBAAA;EAhZR;EAoZM;IACE,gBAAA;EAlZR;EAqZQ;IACE,gBAAA;EAnZV;EAwZM;IACE,gBAAA;EAtZR;AACF;AAyZI;EACE;IACE,YAAA;EAvZN;EA0ZM;IACE,eAAA;EAxZR;EA2ZQ;IACE,eAAA;EAzZV;EA4ZU;IACE,gBAAA;IACA,gBAAA;EA1ZZ;EA4ZY;IACE,eAAA;EA1Zd;AACF;AAkaE;EACE;IACE,mBAAA;IACA,iBAAA;EAhaJ;EAkaI;IACE,kBAAA;IACA,yBAAA;IACA,YAAA;IACA,iBAAA;IACA,iCAAA;EAhaN;EAkaI;IACE,yBAAA;IACA,8BAAA;IACA,yBAAA;EAhaN;EAmaE;IACE,gBAAA;IACA,SAAA;IACA,qBAAA;EAjaJ;EAmaE;IACE,WAAA;IACA,iBAAA;IACA,uBAAA;EAjaJ;EAmaE;IACE,cAAA;EAjaJ;EAmaE;IACE,kBAAA;IACA,2CAAA;IACA,0CAAA;IACA,aAAA;EAjaJ;EAmaI;IACE,aAAA;EAjaN;EAmaM;IACE,eAAA;EAjaR;EAqaE;IACE,SAAA;IACA,YAAA;IACA,iBAAA;IACA,uBAAA;EAnaJ;EAqaI;IACE,UAAA;EAnaN;EAsaI;IACE,gBAAA;EApaN;AACF;AAuaE;EACE;IACE,SAAA;EAraJ;AACF;AAuaE;EACE;IACE,uBAAA;EAraJ;EAuaE;IACE,aAAA;EAraJ;EAuaE;IACE,uBAAA;EAraJ;EAwaI;IACE,YAAA;EAtaN;EAyaM;IACE,mBAAA;EAvaR;EA6aM;IACE,wBAAA;IACA,2BAAA;EA3aR;EAmbM;IACE,gBAAA;EAjbR;EAqbM;IACE,iBAAA;EAnbR;EAubM;IACE,WAAA;IACA,gBAAA;EArbR;AACF;AAybE;EACE;IACE,iBAAA;EAvbJ;EAybI;IACE,aAAA;EAvbN;EAybI;IACE,WAAA;EAvbN;AACF;AA0bE;EAEI;IACE,WAAA;EAzbN;AACF;AA4bE;EAEI;IACE,WAAA;EA3bN;EA8bE;IAEE,eAAA;EA7bJ;AACF;AA+bE;EAEI;IACE,WAAA;EA9bN;EAicE;IAEE,iBAAA;EAhcJ;AACF;AAkcE;EAEI;IACE,aAAA;EAjcN;EAocE;IAEE,eAAA;EAncJ;AACF;;AAucA;EACE,kEAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EAGE,oBAAA;EACA,iBAAA;EACA,eAAA;EAGF,+BAAA;EACA,iDAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAxcF;AA0cE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAxcJ;AA0cI;EACE,WAAA;EACA,YAAA;AAxcN;AA2cI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EAGE,iBAAA;EACA,cAAA;EACA,iBAAA;EAGF,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7cN;AAidE;EAnDF;IAoDI,kBAAA;IACA,kBAAA;EA9cF;AACF","sourcesContent":[".planning {\n  &__breadcrumb {\n    display: none;\n    margin-bottom: 35px;\n  }\n  &__content {\n    display: flex;\n    flex-direction: column;\n    min-height: calc(100dvh - 56px);\n\n    &--right {\n      position: relative;\n      display: flex;\n      flex: 1;\n      justify-content: space-between;\n      flex-direction: column;\n    }\n  }\n  &__wrapper--right {\n    width: 100%;\n    padding: 24px 16px;\n  }\n  &__step {\n    width: 100%;\n\n    &--title {\n      display: none;\n      font: {\n        size: 27px;\n        weight: 700;\n      }\n      color: var(--sebrae-blue-6);\n      margin-bottom: 16px;\n      align-items: center;\n      gap: 5px;\n\n      span {\n        font: {\n          size: 13px;\n          weight: 400;\n        }\n      }\n    }\n  }\n  &__footer {\n    position: sticky;\n    bottom: 0;\n    left: 0;\n    padding: 16px;\n    width: 100%;\n    z-index: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 15px;\n    background-color: var(--sebrae-white);\n\n    &-info {\n      display: flex;\n      justify-content: flex-end;\n      margin-left: auto;\n\n      .template-buttons-wrapper {\n        display: flex;\n        gap: 16px;\n\n        @media screen and (max-width: 767px) {\n          width: 70dvw;\n          max-width: 70dvw;\n        }\n\n        @media screen and (max-width: 448px) {\n          width: 64dvw;\n          max-width: 64dvw;\n        }\n      }\n\n      @media screen and (max-width: 768px) {\n        margin-left: unset !important;\n      }\n\n      @media screen and (max-width: 624px) {\n        width: 100%;\n        justify-content: space-between;\n      }\n    }\n\n    &.under-buttons {\n      z-index: 0;\n    }\n\n    .id-holder {\n      padding: 8px;\n      background-color: var(--sebrae-white-3);\n      border: 1px solid #8FB8EF;\n      color: var(--sebrae-blue-2);\n      border-radius: 100px;\n      font-size: 13px;\n      text-align: center;\n      cursor: pointer;\n      transition: 0.15s ease-in-out;\n\n      &:hover {\n        opacity: 0.65;\n      }\n    }\n\n    button {\n      flex: 1;\n\n      img {\n        width: 18px;\n        height: 18px;\n      }\n    }\n\n    @media screen and (max-width: 624px) {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  }\n  .step {\n    &--info {\n      padding-bottom: 16px;\n      border-bottom: 1px solid var(--sebrae-light-gray4);\n      margin-bottom: 32px;\n    }\n    &--title,\n    &--subtitle {\n      color: var(--sebrae-gray);\n    }\n    &--title {\n      font-size: 16px;\n      margin-bottom: 8px;\n      line-height: 1.2;\n    }\n    &--subtitle {\n      font-size: 13px;\n      margin-bottom: 8px;\n      line-height: 1.2;\n\n      &.icon {\n        display: flex;\n        align-items: flex-start;\n        gap: 6px;\n      }\n    }\n    .BaSe--grid {\n      gap: 16px !important;\n    }\n    .error-message {\n      font-size: 11px;\n      color: var(--sebrae-red);\n\n      @media screen and (min-width: 375px) {\n        font-size: 12px;\n      }\n    }\n\n    &.variable-indirect-costs,\n    &.monthly-average {\n      .BaSe--grid {\n        gap: 0 !important;\n\n        .BaSe--grid {\n          gap: 16px !important;\n        }\n      }\n    }\n    &.total-investment {\n      .BaSe--grid {\n        gap: 0 !important;\n      }\n    }\n    &.variable-indirect-costs,\n    &.total-investment,\n    &.receipt-deadline,\n    &.payment-terms,\n    &.inventory-turnover {\n      .step--info {\n        margin-bottom: 16px;\n      }\n      .accordion-modal {\n        margin-bottom: 24px;\n      }\n      .grid-buttons-area {\n        .BaSe--grid {\n          .BaSe--grid-item {\n            &:last-child {\n              padding-top: 14px;\n              // grid-column: span 1 !important;\n            }\n          }\n        }\n      }\n    }\n    &.inventory-turnover {\n      .btn-add-more {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        margin: 16px auto 0;\n        color: var(--sebrae-blue-6);\n        font: {\n          size: 13px;\n          weight: 700;\n        }\n      }\n      .result {\n        .input-100 {\n          .BaSe--input {\n            margin: 0;\n\n            .BaSe--input-wrapper {\n              border-radius: 4px;\n              overflow: hidden;\n            }\n            input {\n              background: var(--sebrae-white);\n              border-radius: 4px !important;\n              border-width: 2px !important;\n              border-image-slice: 1 !important;\n              border-image-source: linear-gradient(\n                to right,\n                #3b4aff 0%,\n                #40bbff 100%\n              ) !important;\n            }\n          }\n        }\n        .input-not-100 {\n          .BaSe--input {\n            margin: 0;\n\n            .BaSe--input-wrapper {\n              border-radius: 4px;\n              overflow: hidden;\n            }\n\n            input {\n              background: var(--sebrae-white);\n              border-radius: 4px !important;\n              border-width: 2px !important;\n              border-image-slice: 1 !important;\n              border-image-source: linear-gradient(\n                to right,\n                #ff3b3b 0%,\n                #760303 100%\n              ) !important;\n            }\n          }\n        }\n      }\n      .text-muted {\n        margin-top: 32px;\n        display: inline-block;\n      }\n    }\n    &.cash-flow {\n      .modal-second-section,\n      .modal-third-section,\n      .modal-fourth-section {\n        gap: 16px;\n        width: 100%;\n        display: flex;\n        margin-top: 24px;\n        justify-content: space-between;\n      }\n      .modal-fourth-section {\n        margin-bottom: 34px;\n\n        div {\n          flex: 1;\n        }\n      }\n      .modal-fampe-area {\n        h3 {\n          font-size: 16px;\n          font-weight: 700;\n          font-style: normal;\n          margin-bottom: 1px;\n        }\n      }\n      .fampe-range-status {\n        padding: 16px;\n        margin: 32px 0;\n        border-radius: 4px;\n        border: 1px solid var(--sebrae-dark-green3);\n        background-color: var(--sebrae-light-green4);\n\n        h3 {\n          font-size: 13px;\n          font-weight: 700;\n          margin-bottom: 8px;\n          color: var(--sebrae-dark-green3);\n        }\n\n        p {\n          font-size: 13px;\n          font-weight: 400;\n          color: var(--sebrae-dark-green3);\n        }\n\n        &.fampe-80 {\n          border-color: var(--sebrae-dark-green3);\n          background-color: var(--sebrae-light-green4);\n\n          h3,\n          p {\n            color: var(--sebrae-dark-green3);\n          }\n        }\n\n        &.fampe-over {\n          border-color: #ffbf40;\n          background-color: #fec;\n\n          h3,\n          a,\n          p {\n            color: #8f6b24;\n          }\n        }\n\n        &.fampe-under {\n          border-color: #2e5de6;\n          background-color: #cfe2fc;\n\n          h3,\n          p {\n            color: #2e5de6;\n          }\n        }\n      }\n\n      .values-area {\n        .main-value {\n          gap: 6px;\n          width: 100%;\n          display: flex;\n          padding: 16px;\n          border-radius: 8px;\n          margin-bottom: 32px;\n          align-items: flex-start;\n          background-color: var(--sebrae-white-3);\n          border: 1px solid var(--sebrae-light-gray5);\n          box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n\n          .bg-img {\n            padding: 8px;\n            border-radius: 150px;\n            background-color: var(--sebrae-light-blue3);\n          }\n          img {\n            width: 24px;\n            object-fit: contain;\n          }\n\n          h3 {\n            color: var(--sebrae-blue);\n            font-family: Figtree;\n            font-size: 23px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: normal;\n            margin-top: 6px;\n            margin-bottom: 12px;\n          }\n        }\n        .other-values {\n          gap: 16px;\n          display: flex;\n          flex-direction: column;\n          margin-top: 16px;\n\n          @media (min-width: 550px) {\n            flex-direction: row;\n          }\n\n          &:first-child {\n            margin-top: 0;\n          }\n\n          &-value {\n            flex: 1;\n            gap: 6px;\n            display: flex;\n            padding: 16px;\n            border-radius: 8px;\n            align-items: flex-start;\n            border: 1px solid var(--sebrae-light-gray5);\n            box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n\n            &-text {\n              gap: 4px;\n              height: 100%;\n              display: flex;\n              flex-direction: column;\n\n              h3 {\n                margin-top: 2px;\n                font-size: 13px;\n                font-weight: 700;\n                font-style: normal;\n                color: var(--sebrae-blue);\n              }\n            }\n          }\n\n          img {\n            width: 16px;\n            object-fit: contain;\n          }\n\n          .bg-img {\n            padding: 8px;\n            border-radius: 150px;\n            background-color: var(--sebrae-light-blue3);\n\n            .percentage {\n              width: 16px;\n              height: 16px;\n              padding: 2px;\n            }\n          }\n        }\n      }\n      .modal-button-area {\n        gap: 8px;\n        display: flex;\n        margin-top: 32px;\n        justify-content: end;\n\n        button {\n          max-width: 175px;\n        }\n\n        &-button {\n          max-width: 68px;\n        }\n      }\n      .btns-area {\n        gap: 16px;\n        display: flex;\n        margin-top: 16px;\n        flex-direction: column;\n\n        @media (min-width: 769px) {\n          flex-direction: row;\n\n          button {\n            &:last-child {\n              max-width: 223px;\n            }\n          }\n        }\n      }\n      .new-credit-area {\n        margin-top: 16px;\n\n        &-buttons {\n          gap: 16px;\n          display: flex;\n          margin-top: 16px;\n        }\n      }\n      .cash-flow__title {\n        color: var(--sebrae-blue-6);\n        font: {\n          family: Campuni;\n          size: 20px;\n          weight: 700;\n        }\n        margin-bottom: 5px;\n      }\n      .cash-flow__wrapper {\n        position: relative;\n        overflow: hidden;\n        margin: -2px -2px;\n        padding: 2px;\n      }\n      .wrapper-flux {\n        min-width: 250px;\n\n        .default {\n          padding: 16px;\n          display: flex;\n          align-items: center;\n          box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n          margin-bottom: 16px;\n          justify-content: space-between;\n          font-size: 14px;\n        }\n        .date {\n          border-radius: 4px;\n          border: 1px solid var(--sebrae-light-gray4);\n          background: var(--sebrae-white-4);\n          height: 40px;\n          color: var(--sebrae-gray);\n          font-style: normal;\n          font-weight: 400;\n          line-height: 23.3px;\n          @extend .default;\n\n          &.not-menu {\n            background-color: transparent;\n            box-shadow: none;\n            border: 0;\n            opacity: 0;\n          }\n        }\n        h3 {\n          border-radius: 4px;\n          background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);\n          box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n          height: 48px;\n          color: var(--sebrae-white);\n          font-style: normal;\n          font-weight: 700;\n          line-height: 23.3px;\n          @extend .default;\n\n          &.gradient {\n            background: var(--sebrae-white);\n            color: var(--sebrae-gray);\n          }\n          &.has-balance {\n            background: linear-gradient(15deg, #9285f9 0%, #cd5be8 100%);\n          }\n        }\n        .exits {\n          .card-flux {\n            &:first-of-type {\n              padding: 10px 15px;\n\n              &.output-open {\n                min-height: 48px;\n              }\n\n              &.output-closed {\n                min-height: 56px;\n              }\n            }\n          }\n          .empty {\n            background: transparent;\n            box-shadow: none;\n            p {\n              visibility: hidden;\n            }\n          }\n          .content {\n            width: 100%;\n          }\n        }\n        .wrapper-card {\n          .card-flux {\n            margin-bottom: 0;\n            padding: 10px 15px;\n\n            &:first-child {\n              margin-bottom: 14px;\n            }\n            &:last-child {\n              margin-bottom: 15px;\n            }\n            p {\n              padding: 0;\n            }\n\n            &__strong {\n              font-size: 16px;\n              font-weight: 700;\n            }\n          }\n        }\n        .card-flux {\n          border-radius: 4px;\n          background: var(--sebrae-white);\n          color: var(--sebrae-gray);\n          font-style: normal;\n          font-weight: 700;\n          line-height: 1.2;\n          width: 100%;\n          align-items: center;\n          min-height: 56px;\n          @extend .default;\n\n          &-gray {\n            background: var(--sebrae-light-gray4);\n            color: var(--sebrae-gray);\n\n            &.active {\n              background-color: var(--sebrae-light-blue3);\n              color: var(--sebrae-blue-6);\n            }\n          }\n\n          .title {\n            gap: 8px;\n            display: flex;\n            min-height: 35px;\n            align-items: center;\n            margin-bottom: 18px;\n\n            img {\n              cursor: pointer;\n            }\n\n            &.title-collapsed {\n              margin-bottom: 0 !important;\n            }\n\n            &.title-expanded {\n              margin-bottom: 18px !important;\n            }\n\n            &-values {\n              width: 100%;\n            }\n\n            &-right {\n              width: 100%;\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n            }\n          }\n          .title-exits {\n            width: 100%;\n            display: flex;\n            justify-content: space-between;\n\n            p {\n              margin: 0;\n              font-size: 16px;\n              font-weight: 400;\n              color: var(--sebrae-gray);\n            }\n\n            &:last-of-type {\n              p {\n                padding: 0;\n              }\n            }\n\n            .action-buttons {\n              gap: 10px;\n              display: flex;\n              padding-right: 16px;\n\n              &.is-disabled {\n                > *:last-child {\n                  cursor: not-allowed !important;\n                  opacity: 0.4;\n                  filter: grayscale(1);\n                }\n              }\n            }\n          }\n\n          p {\n            color: var(--sebrae-dark-gray2);\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 23.3px;\n            padding-bottom: 17px;\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n\n            &:last-child {\n              padding: 0;\n            }\n          }\n\n          .arrow {\n            border: 1px solid var(--sebrae-dark-gray2);\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n\n          &.small {\n            padding: 8px 15px;\n            min-height: 40.3px;\n            margin-bottom: 0 !important;\n          }\n          &.balance {\n            flex-direction: column;\n\n            &.expanded {\n              max-height: 100px;\n            }\n\n            &.collapsed {\n              min-height: 56px !important;\n            }\n\n            .header {\n              gap: 8px;\n              width: 100%;\n              display: flex;\n              padding-top: 2px;\n              align-items: center;\n\n              &-content {\n                width: 100%;\n                display: flex;\n                align-items: end;\n                justify-content: space-between;\n              }\n\n              .icon-arrow {\n                img {\n                  cursor: pointer;\n                }\n              }\n            }\n            .has-balance {\n              width: 100%;\n              margin-top: 5px;\n            }\n            p {\n              padding: 0;\n              margin: 0 0 2px;\n              font: {\n                size: 13px;\n              }\n              line-height: 1.3;\n              color: var(--sebrae-dark-gray2);\n            }\n\n            &.has-balance {\n              min-height: 100px;\n            }\n            &.small {\n              min-height: 56px;\n              margin-bottom: 60px !important;\n              justify-content: center;\n              align-items: start;\n\n              &.expanded {\n                margin-bottom: 60px !important;\n              }\n\n              &.collapsed {\n                margin-bottom: 16px !important;\n              }\n            }\n          }\n        }\n        &.title {\n          min-width: 100%;\n        }\n        &.dynamic {\n          .exits {\n            .card-flux {\n              margin-bottom: 8px;\n\n              &-value {\n                gap: 8px;\n                display: flex;\n                align-items: center;\n              }\n            }\n          }\n        }\n      }\n      .SettingsSliderCashFlow {\n        &.slick-slider {\n          margin: 0 -16px !important;\n        }\n        .slick-track {\n          display: flex !important;\n        }\n        .slick-slide {\n          height: inherit !important;\n\n          div:first-child {\n            height: 100%;\n          }\n        }\n        .slick {\n          &-list {\n            .wrapper-flux {\n              padding-left: 15px;\n            }\n          }\n\n          &-dots {\n            position: relative;\n            bottom: 0;\n\n            li {\n              width: 18px;\n              height: 10px;\n              button {\n                background-color: #005eb8;\n                border-radius: 50%;\n                opacity: 1;\n                width: 10px;\n                height: 10px;\n                transition: 0.3s;\n                font-size: 1px;\n\n                &:before {\n                  content: none;\n                }\n              }\n              &.slick-active {\n                button {\n                  border-radius: 66.667px;\n                  width: 18px;\n                }\n              }\n            }\n          }\n\n          @media (min-width: 767px) {\n            &-list {\n              overflow: visible;\n            }\n          }\n        }\n        .wrapper-flux {\n          position: relative;\n          height: 100%;\n          padding-bottom: 72px;\n\n          .capacity {\n            position: absolute;\n            bottom: 16px;\n            left: 0;\n            right: 0;\n            width: calc(100% - 15px);\n            margin: 0 0 0 auto;\n            padding: 10px 16px;\n          }\n        }\n        &.empty {\n          .wrapper-flux {\n            padding-left: 0;\n\n            .capacity {\n              width: 100%;\n            }\n          }\n        }\n      }\n      .label-installments {\n        padding: 10px 0;\n        border-top: 1px solid var(--sebrae-light-gray4);\n        margin-top: 16px;\n      }\n      .form {\n        &-date {\n          .description {\n            font-weight: 600;\n            span {\n              color: var(--sebrae-gray);\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 400;\n              line-height: 23.3px;\n              display: block;\n              padding-top: 16px;\n            }\n          }\n          label {\n            color: var(--sebrae-gray) !important;\n            font-size: 15px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n            padding-bottom: 5px;\n          }\n        }\n\n        &-initial-values {\n          .description {\n            font-weight: 500;\n            padding-bottom: 16px;\n          }\n\n          .wrapper-date {\n            max-width: 50%;\n            margin-bottom: 16px;\n          }\n\n          label {\n            color: var(--sebrae-dark-gray2) !important;\n            font-size: 15px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n            padding-bottom: 5px;\n          }\n        }\n      }\n      .date {\n        .currency {\n          padding: 10px 0 0;\n        }\n        .wrapper-date {\n          display: flex;\n          gap: 20px;\n\n          & > div {\n            width: 100%;\n          }\n        }\n        .inputs {\n          &.months {\n            display: flex;\n            gap: 20px;\n          }\n        }\n      }\n      .BaSe--checkbox {\n        div {\n          &:last-child {\n            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n            width: 18px;\n            height: 18px;\n          }\n        }\n      }\n      .additional-month {\n        max-height: 170px;\n        overflow: auto;\n        padding-right: 15px;\n        margin-right: -10px;\n        margin-top: 15px;\n      }\n      .wrapper-button {\n        padding: 20px 0 10px;\n        text-align: right;\n\n        button {\n          background-color: var(--sebrae-blue);\n          color: var(--sebrae-white);\n          border-radius: 4px;\n          height: 40px;\n          padding: 0 15px;\n        }\n      }\n      button {\n        &:disabled {\n          opacity: 0.7;\n          cursor: no-drop;\n        }\n      }\n      .cash-flow__quick-view {\n        position: relative;\n        margin-top: 24px;\n\n        &.mobile {\n          .BaSe--select {\n            margin-bottom: 8px;\n          }\n          .clear {\n            text-align: right;\n          }\n          .link {\n            color: var(--sebrae-blue-6);\n            font-size: 13px;\n          }\n        }\n        &.desktop {\n          display: none;\n\n          h6 {\n            font: {\n              size: 16px;\n              weight: 700;\n            }\n            margin-bottom: 15px;\n            color: var(--sebrae-blue-6);\n          }\n          .months {\n            display: flex;\n            gap: 16px;\n            flex-wrap: wrap;\n\n            .month {\n              width: 140px;\n              height: 40px;\n              border: 1px solid var(--sebrae-light-gray2);\n              border-radius: 4px;\n              padding: 4px;\n              font: {\n                size: 13px;\n                weight: 400;\n              }\n              color: var(--sebrae-gray);\n              background: transparent;\n              transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n              &.active {\n                background-color: var(--sebrae-blue-6);\n                border-color: var(--sebrae-blue-6);\n                color: var(--sebrae-white);\n                font-weight: 700;\n              }\n            }\n          }\n        }\n      }\n\n      @media screen and (min-width: 375px) {\n        .wrapper-flux {\n          .default {\n            font-size: 16px;\n          }\n        }\n      }\n      @media screen and (min-width: 767px) {\n        .slick-initialized {\n          .wrapper-flux {\n            min-width: 302px;\n            width: 302px;\n          }\n        }\n        .wrapper-flux {\n          min-width: 286px;\n          width: 286px;\n\n          &.dynamic {\n            .exits {\n              .card-flux {\n                &.small {\n                  p {\n                    color: var(--sebrae-gray);\n                  }\n                }\n\n                &__strong {\n                  color: var(--sebrae-gray);\n                }\n              }\n            }\n          }\n\n          .horizontal-bar {\n            border-bottom: 1px solid var(--sebrae-light-gray4);\n            margin-bottom: 16px;\n\n            &.without-border {\n              border-bottom: 1px solid transparent;\n              margin-bottom: 16px;\n            }\n          }\n        }\n        .additional-month {\n          max-height: 280px;\n          // display: grid;\n          // grid-template-columns: 1fr 1fr;\n          gap: 0 16px;\n        }\n        .date {\n          .BaSe--select,\n          .wrapper-date div {\n            max-width: 204px;\n          }\n          .inputs.months {\n            .wrapper-select,\n            .wrapper-date {\n              flex: 1;\n            }\n          }\n        }\n      }\n\n      @media screen and (min-width: 769px) and (max-width: 1023px) {\n        .SettingsSliderCashFlow {\n          &.empty {\n            padding-left: 15px;\n          }\n        }\n      }\n      @media screen and (min-width: 1024px) {\n        .SettingsSliderCashFlow {\n          display: grid;\n          grid-auto-flow: column;\n          grid-auto-columns: max-content;\n          gap: 16px;\n        }\n        .cash-flow__wrapper {\n          overflow-x: auto;\n          scrollbar-width: thin;\n          scrollbar-color: #d9d9d9 transparent;\n        }\n        .wrapper-flux {\n          &.title {\n            margin: 15px 0 23px;\n          }\n          .capacity {\n            width: 100% !important;\n            margin: 0 !important;\n          }\n        }\n        .cash-flow__quick-view {\n          &.desktop {\n            display: block;\n          }\n          &.mobile {\n            display: none;\n          }\n        }\n        .additional-month {\n          max-height: 160px;\n        }\n      }\n      @media screen and (min-width: 1280px) {\n        .wrapper-button {\n          padding-top: 10px;\n          padding-bottom: 0;\n        }\n        .additional-month {\n          max-height: 100%;\n        }\n        .dialog-exists {\n          .wrapper-modal {\n            max-height: 98dvh;\n          }\n          .modal-body {\n            height: 520px;\n            overflow-y: auto;\n          }\n        }\n      }\n    }\n    &.results {\n      max-width: 100% !important;\n\n      .accordion-block-tip {\n        padding: 0 24px 24px;\n\n        p {\n          font-size: 13px;\n        }\n      }\n\n      .title-result {\n        font-size: 16px;\n        padding-bottom: 19px;\n      }\n\n      .accordion-content-internal {\n        padding-bottom: 16px;\n\n        .first-block {\n          flex: 1;\n\n          h6 {\n            font-size: 19px;\n            font-weight: 700;\n            text-align: center;\n          }\n\n          p {\n            font-size: 13px;\n            max-width: 139px;\n          }\n\n          span {\n            display: flex;\n            padding-right: 16px;\n            align-items: center;\n            justify-content: space-between;\n          }\n        }\n\n        .second-block {\n          flex: 1;\n          gap: 8px;\n          display: flex;\n          padding: 16px;\n          border-radius: 4px;\n          align-items: center;\n          flex-direction: column;\n          border: 1px solid #d4dadd;\n\n          h6 {\n            font-size: 11px;\n          }\n\n          p {\n            font-size: 11px;\n            font-style: italic;\n            text-align: center;\n\n            span {\n              font-weight: 700;\n            }\n          }\n\n          &-title {\n            gap: 4.5px;\n            display: flex;\n            align-items: center;\n\n            img {\n              width: 11px;\n              height: 11px;\n            }\n          }\n        }\n      }\n\n      .sections-bar {\n        margin-bottom: 24px;\n        border-bottom: 1px solid #3c4143;\n\n        &.internal {\n          margin-bottom: 0;\n          margin: 16px 0;\n        }\n\n        &.with-top {\n          margin-top: 24px;\n        }\n\n        &.light {\n          border-color: var(--sebrae-light-gray4) !important;\n        }\n\n        &.without-top {\n          margin: 0;\n          margin-bottom: 16px;\n        }\n\n        &.external {\n          margin-bottom: 0;\n          margin: 24px 0;\n        }\n      }\n\n      .notes-modal {\n        display: flex;\n        flex-direction: column;\n        align-items: end;\n\n        span {\n          font-weight: bold;\n        }\n      }\n      .results-and-calculations {\n        gap: 8px;\n        display: flex;\n        flex-direction: column;\n\n        &.special-result {\n          margin-bottom: 24px;\n        }\n\n        .second-block {\n          flex: 1;\n          padding: 16px;\n          border-radius: 4px;\n          border: 1px solid #d4dadd;\n\n          // &.special {\n          //   max-height: 120px;\n          // }\n\n          &-title {\n            gap: 4.5px;\n            display: flex;\n            align-items: center;\n            padding-bottom: 16px;\n\n            h6 {\n              font-size: 13px;\n            }\n\n            img {\n              width: 11px;\n              height: 11px;\n            }\n          }\n\n          &-content {\n            padding-bottom: 24px;\n\n            span {\n              font-weight: 700;\n            }\n\n            h6,\n            p {\n              font-size: 13px;\n            }\n\n            p {\n              margin-top: 8px;\n              color: #3c4143;\n              font-style: italic;\n            }\n          }\n        }\n      }\n\n      .results-information {\n        border-radius: 8px;\n        // padding-bottom: 8px;\n        background-color: #fff;\n        border: 1px solid var(--sebrae-light-gray4);\n        // box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.08);\n\n        &.special-results {\n          display: flex;\n          // max-height: 120px;\n          flex-direction: column;\n          justify-content: space-between;\n        }\n\n        &__data {\n          padding-left: 16px;\n          display: flex;\n          flex-wrap: wrap;\n          flex: 1;\n          align-items: stretch;\n          // align-items: center;\n          justify-content: space-between;\n          min-height: 56px;\n          border-bottom: 1px solid var(--sebrae-light-gray4);\n          margin-bottom: 0 !important;\n\n          &.no-border {\n            flex: 1;\n            border: none !important;\n          }\n        }\n\n        &__info {\n          width: 50%;\n          display: flex;\n          padding: 8px 0;\n          font-size: 13px;\n          align-items: center;\n          word-wrap: break-word;\n        }\n\n        &__value {\n          width: 50%;\n          display: flex;\n          font-size: 13px;\n          align-items: center;\n          justify-content: center;\n          background-color: transparent;\n\n          &.highlighted {\n            font-size: 16px;\n            min-height: 56px;\n            background-color: var(--sebrae-light-blue3);\n            padding: 4px 0;\n          }\n\n          &.big-number {\n            font-size: 11px;\n          }\n        }\n      }\n      .message-observation {\n        text-align: end;\n\n        p {\n          font-size: 13px;\n          padding-top: 5px;\n        }\n      }\n      .second-tip-block {\n        h6 {\n          font-size: 20px;\n          font-weight: 900;\n        }\n      }\n\n      .bar {\n        border-bottom: 1px solid var(--sebrae-light-gray4);\n        margin: 24px 0;\n\n        &.last {\n          margin: 48px 0 24px;\n        }\n      }\n      .title {\n        padding: 24px 0 8px;\n\n        &.square-title {\n          padding: 0;\n          padding-bottom: 16px;\n        }\n      }\n      .goal {\n        padding: 16px;\n        display: flex;\n        gap: 16.3px;\n        background-color: #fff;\n\n        &__input-area {\n          .date-picker {\n            position: relative !important;\n          }\n        }\n\n        img {\n          align-self: flex-start;\n          padding-top: 2px;\n        }\n\n        p {\n          padding-bottom: 16px;\n        }\n      }\n\n      .technical-notes {\n        p {\n          cursor: pointer;\n          max-width: 196px;\n          text-decoration: underline;\n          color: var(--sebrae-dark-gray2);\n\n          &:hover {\n            color: #000;\n            p {\n              color: #000;\n            }\n          }\n        }\n      }\n\n      .form {\n        .chart-area {\n          .wrapper-select {\n            display: flex;\n            align-items: center;\n            gap: 15px;\n\n            .btn-clear {\n              font-size: 12px;\n              font-style: normal;\n              font-weight: 700;\n              line-height: 23.3px;\n              background-color: var(--sebrae-blue);\n              color: var(--sebrae-white);\n              padding: 5px 10px;\n              border-radius: 5px;\n              margin-top: 12px;\n              width: 100px;\n            }\n          }\n          &__data {\n            padding: 30px 0;\n          }\n\n          div[width=\"286\"] {\n            z-index: 2;\n          }\n\n          div {\n            input {\n              width: 100%;\n            }\n          }\n        }\n        .submit-and-download {\n          display: flex;\n          justify-content: center;\n          padding: 24px 20px;\n        }\n\n        .BaSe--input-input {\n          border-color: var(--sebrae-light-gray5) !important;\n        }\n        textarea {\n          min-height: 148px;\n        }\n      }\n      .finish-and-download {\n        display: flex;\n      }\n\n      @media screen and (min-width: 768px) {\n        padding-bottom: 40px;\n        max-width: max-content;\n\n        .technical-notes {\n          display: flex;\n          justify-content: center;\n\n          p {\n            text-align: center;\n          }\n        }\n\n        .chart-area {\n          .wrapper-select {\n            max-width: 100%;\n\n            .BaSe--input {\n              max-width: 100%;\n            }\n\n            .BaSe--select {\n              width: 100%;\n            }\n          }\n        }\n\n        .accordion-content-internal {\n          display: flex;\n          padding: 0 60px;\n          margin-bottom: 24px;\n          flex-direction: row;\n          align-items: center;\n          justify-content: center;\n\n          .first-block {\n            padding-right: 58px;\n\n            p {\n              font-size: 16px;\n            }\n          }\n        }\n\n        .sections-bar {\n          &.without-bottom {\n            margin: 0;\n            margin-top: 16px;\n          }\n\n          &.mobile {\n            display: none;\n          }\n        }\n\n        .results-space {\n          padding-top: 32px;\n        }\n\n        .inputs-area {\n          gap: 23px;\n          display: flex;\n          justify-content: space-between;\n\n          div {\n            flex: 1;\n\n            .BaSe--input {\n              max-width: 100%;\n\n              @media screen and (min-width: 769px) {\n                &-label {\n                  font-size: 1.85vw !important;\n                  line-height: 1.2;\n                }\n              }\n              @media screen and (min-width: 992px) {\n                &-label {\n                  font-size: 1.4vw !important;\n                }\n              }\n              @media screen and (min-width: 1024px) {\n                &-label {\n                  font-size: 16px !important;\n                }\n              }\n            }\n            .input-textarea {\n              @media screen and (min-width: 769px) {\n                &-label {\n                  font-size: 1.85vw !important;\n                  line-height: 1.2;\n                }\n              }\n              @media screen and (min-width: 992px) {\n                &-label {\n                  font-size: 1.4vw !important;\n                }\n              }\n              @media screen and (min-width: 1024px) {\n                &-label {\n                  font-size: 16px !important;\n                }\n              }\n            }\n          }\n        }\n\n        .title-result {\n          font-size: 16px;\n\n          &.mobile {\n            display: none;\n          }\n        }\n\n        .results-information {\n          &__info {\n            .tooltip-capital {\n              align-self: normal;\n              padding-top: 10.5px;\n            }\n          }\n        }\n\n        .form {\n          .submit-and-download {\n            display: none;\n          }\n\n          .technical-notes {\n            padding: 24px 0;\n          }\n        }\n      }\n      @media (min-width: 970px) and (max-width: 1023px) {\n        .results-information {\n          &__info {\n            .tooltip-capital {\n              padding: 0;\n              align-self: center;\n            }\n          }\n        }\n      }\n\n      @media screen and (min-width: 992px) {\n        .results-information {\n          padding-bottom: 0;\n\n          &__info {\n            width: 48%;\n          }\n\n          &__value {\n            width: 52%;\n            text-align: center;\n            letter-spacing: -0.7px;\n          }\n        }\n\n        .form {\n          .goal {\n            justify-content: flex-start;\n          }\n        }\n      }\n      @media screen and (min-width: 1024px) {\n        .results-and-calculations {\n          gap: 24px;\n          flex-direction: row;\n\n          &.special-result {\n            margin-bottom: 16px;\n          }\n\n          .results-information {\n            flex: 1;\n\n            &__value {\n              &.highlighted {\n                font-size: 19px;\n              }\n\n              &.big-number {\n                font-size: 11px;\n              }\n            }\n          }\n        }\n\n        .form {\n          .chart-area {\n            &__data {\n              padding: 30px 0;\n            }\n          }\n        }\n      }\n      @media screen and (min-width: 1280px) {\n        .results-information {\n          &__info {\n            width: 55%;\n          }\n          &__value {\n            width: 45%;\n            letter-spacing: normal;\n          }\n        }\n      }\n    }\n  }\n\n  .business-accordion {\n    box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n    border-radius: 8px;\n    overflow: hidden;\n    background-color: #ebe8ff;\n\n    .custom-accordion-header {\n      cursor: pointer;\n      padding: 24px 24px 16px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 16px;\n      transition: background-color 0.3s ease;\n\n      .custom-accordion-title {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        flex: 1;\n\n        span {\n          font-weight: 600;\n          font-size: 16px;\n          line-height: 20px;\n          color: var(--sebrae-blue-2);\n        }\n\n        @media (max-width: 880px) {\n          gap: 6px;\n          img {\n            width: 24px;\n            height: 24px;\n          }\n          span {\n            font-size: 15px;\n            line-height: 19px;\n          }\n        }\n      }\n\n      .custom-accordion-arrow {\n        border: 1px solid #617385;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n\n        figure {\n          margin: 0;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          @media (max-width: 880px) {\n            img {\n              width: 18px;\n              height: 18px;\n            }\n          }\n        }\n      }\n\n      @media (max-width: 880px) {\n        padding: 24px 12px 16px;\n        gap: 8px;\n      }\n    }\n\n    .custom-accordion-content {\n      max-height: 0;\n      overflow: hidden;\n      transition: max-height 0.25s ease-in-out, padding 0.25s ease-in-out;\n\n      &.active {\n        max-height: 1000px;\n        padding: 0 24px 24px;\n\n        @media (max-width: 880px) {\n          padding: 0 12px 24px;\n        }\n      }\n    }\n\n    .accordion-content {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 16px;\n\n      &-left,\n      &-right {\n        height: fit-content;\n        word-break: normal;\n      }\n\n      &-left {\n        p {\n          font-size: 16px;\n          font-weight: 400;\n          line-height: 23.3px;\n          margin-bottom: 4px;\n        }\n\n        .accordion-checkboxes {\n          display: flex;\n          gap: 16px;\n\n          div[shape=\"square\"] {\n            width: 18px;\n            height: 18px;\n          }\n        }\n      }\n\n      &-right {\n        .input-wrapper {\n          display: flex;\n          align-items: center;\n\n          .wrapper-input {\n            flex: 1;\n          }\n\n          input:disabled {\n            cursor: not-allowed;\n          }\n\n          .BaSe--checkbox {\n            div[shape=\"circle\"] {\n              width: 18px;\n              height: 18px;\n              margin-right: 8px;\n            }\n          }\n        }\n\n        .button-wrapper {\n          display: flex;\n          justify-content: flex-end;\n        }\n      }\n\n      @media (max-width: 555px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    @media (max-width: 768px) {\n      margin-top: 12px;\n    }\n  }\n\n  .projected-flow {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    padding: 16px;\n    background-color: #fff;\n    border: 1px dashed #40bbff;\n    border-radius: 4px;\n    margin-top: 2px;\n    text-align: center;\n\n    p {\n      font-size: 13px;\n      padding-bottom: 16px;\n    }\n    .BaSe--button {\n      margin: 0 auto !important;\n    }\n  }\n  .modal-default {\n    &.dialog-exists {\n      .BaSe--input {\n        max-width: 100%;\n      }\n      form {\n        max-width: 424px;\n        margin: 0 auto;\n      }\n    }\n    &.dialog-alert {\n      &-ncg {\n        .wrapper-modal {\n          .title {\n            font-size: 16px;\n\n            @media screen and (min-width: 768px) {\n              font-size: 19px;\n            }\n          }\n        }\n\n        .dialog-alert {\n          &__description {\n            font-size: 13px;\n          }\n          &__buttons {\n            display: flex;\n            justify-content: flex-end;\n            gap: 8px;\n            margin-top: 24px;\n            flex-wrap: wrap;\n\n            button {\n              min-height: 32px;\n              padding: 5px 12px;\n              flex: 1;\n\n              &:last-of-type {\n                flex: auto;\n              }\n            }\n            span {\n              font-size: 13px;\n            }\n\n            @media screen and (min-width: 768px) {\n              flex-wrap: nowrap;\n              gap: 12px;\n\n              button {\n                flex: none !important;\n              }\n            }\n          }\n          &__checkbox {\n            margin-top: 24px;\n            .BaSe--checkbox {\n              > div {\n                input {\n                  width: 16px;\n                  height: 16px;\n                  margin: 0;\n                }\n                div {\n                  width: 16px;\n                  height: 16px;\n                  border: 1px solid var(--sebrae-blue-2);\n                }\n              }\n              label {\n                font-size: 13px;\n                line-height: 1.2;\n                color: var(--sebrae-gray);\n              }\n            }\n          }\n        }\n      }\n\n      .title {\n        font-size: 16px;\n      }\n      .dialog-alert {\n        &__description {\n          font-size: 13px;\n        }\n        &__buttons {\n          display: flex;\n          justify-content: flex-end;\n          gap: 24px;\n          margin-top: 24px;\n\n          button {\n            min-height: 32px;\n            padding: 5px 12px;\n          }\n          span {\n            font-size: 13px;\n          }\n        }\n        &__checkbox {\n          margin-top: 24px;\n          .BaSe--checkbox {\n            > div {\n              input {\n                width: 16px;\n                height: 16px;\n                margin: 0;\n              }\n              div {\n                width: 16px;\n                height: 16px;\n                border: 1px solid var(--sebrae-blue-2);\n              }\n            }\n            label {\n              font-size: 13px;\n              line-height: 1.2;\n              color: var(--sebrae-gray);\n            }\n          }\n        }\n      }\n\n      &.zero {\n        .dialog-alert__buttons {\n          gap: 16px;\n\n          button {\n            min-width: 137px;\n          }\n        }\n      }\n    }\n    &.dialog-prompt {\n      .dialog-prompt__buttons {\n        display: flex;\n        justify-content: flex-end;\n        gap: 24px;\n        margin-top: 24px;\n      }\n    }\n\n    @media screen and (min-width: 768px) {\n      &.add-initial-balance {\n        .wrapper-modal {\n          max-width: 407px;\n        }\n      }\n      &.dialog-exists {\n        .wrapper-modal {\n          max-width: 488px;\n        }\n      }\n      &.dialog-alert {\n        .wrapper-modal {\n          max-width: 405px;\n        }\n        &.zero {\n          .wrapper-modal {\n            max-width: 343px;\n          }\n        }\n      }\n      &.dialog-prompt {\n        .wrapper-modal {\n          max-width: 410px;\n        }\n      }\n    }\n    @media screen and (min-width: 1024px) {\n      .modal-body {\n        padding: 8px;\n      }\n      &.finish {\n        .title {\n          font-size: 23px;\n        }\n        .dialog-alert {\n          &__description {\n            font-size: 16px;\n          }\n          &__buttons {\n            button {\n              min-height: 40px;\n              min-width: 113px;\n\n              span {\n                font-size: 16px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    &__content {\n      flex-direction: row;\n      min-height: 83dvh;\n\n      &--left {\n        position: relative;\n        padding: 24px 20px 0 24px;\n        width: 295px;\n        text-align: right;\n        background: var(--sebrae-white-3);\n      }\n      &--right {\n        width: calc(100% - 295px);\n        flex-direction: column-reverse;\n        justify-content: flex-end;\n      }\n    }\n    &__wrapper--left {\n      position: sticky;\n      top: 84px;\n      display: inline-block;\n    }\n    &__wrapper--right {\n      width: 100%;\n      max-width: 1120px;\n      padding: 12px 20px 56px;\n    }\n    &__breadcrumb {\n      display: block;\n    }\n    &__step {\n      border-radius: 8px;\n      border: 1px solid var(--sebrae-light-gray4);\n      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);\n      padding: 16px;\n\n      &--title {\n        display: flex;\n\n        span {\n          font-size: 16px;\n        }\n      }\n    }\n    &__footer {\n      top: 56px;\n      bottom: auto;\n      max-width: 1120px;\n      padding: 24px 20px 12px;\n\n      button {\n        flex: none;\n      }\n\n      .BaSe--button {\n        box-shadow: none;\n      }\n    }\n  }\n  @media screen and (min-width: 1200px) {\n    &__footer {\n      top: 60px;\n    }\n  }\n  @media screen and (min-width: 1280px) {\n    &__wrapper--right {\n      padding: 12px 40px 56px;\n    }\n    &__step {\n      padding: 32px;\n    }\n    &__footer {\n      padding: 24px 40px 12px;\n    }\n    .step {\n      &--info {\n        border: none;\n      }\n      &--subtitle {\n        &.icon {\n          align-items: center;\n        }\n      }\n      &.variable-indirect-costs,\n      &.monthly-average,\n      &.total-investment {\n        .BaSe--grid {\n          row-gap: 10px !important;\n          column-gap: 33px !important;\n        }\n      }\n      &.variable-indirect-costs,\n      &.total-investment,\n      &.receipt-deadline,\n      &.payment-terms,\n      &.inventory-turnover {\n        .step--info {\n          margin-bottom: 0;\n        }\n      }\n      &.monthly-average {\n        .step--info {\n          padding-bottom: 0;\n        }\n      }\n      .inventory-turnover {\n        &__wrapper {\n          width: 100%;\n          max-width: 480px;\n        }\n      }\n    }\n  }\n  @media screen and (min-width: 1440px) {\n    &__content {\n      min-height: 88dvh;\n\n      &--left {\n        width: 20.5vw;\n      }\n      &--right {\n        width: 100%;\n      }\n    }\n  }\n  @media screen and (min-width: 1910px) {\n    &__content {\n      &--left {\n        width: 28vw;\n      }\n    }\n  }\n  @media screen and (min-width: 1921px) {\n    &__content {\n      &--left {\n        width: 28vw;\n      }\n    }\n    &__wrapper--right,\n    &__footer {\n      max-width: 58vw;\n    }\n  }\n  @media screen and (min-width: 2550px) {\n    &__content {\n      &--left {\n        width: 34vw;\n      }\n    }\n    &__wrapper--right,\n    &__footer {\n      max-width: 43.5vw;\n    }\n  }\n  @media screen and (min-width: 3830px) {\n    &__content {\n      &--left {\n        width: 39.4vw;\n      }\n    }\n    &__wrapper--right,\n    &__footer {\n      max-width: 29vw;\n    }\n  }\n}\n\n.btn-solution {\n  background-image: linear-gradient(35deg, #cd5be8 0%, #ffabab 100%);\n  width: 100%;\n  padding: 8px 16px;\n  display: flex;\n\n  font: {\n    family: Campuni;\n    weight: bold;\n    size: 12px;\n  }\n\n  color: var(--sebrae-light-gray);\n  box-shadow: 0px 4px 8px 0px rgba(20, 46, 82, 0.2);\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n\n  .wrapper-icon {\n    position: relative;\n    width: 20px;\n    height: 20px;\n\n    img {\n      width: 100%;\n      height: 100%;\n    }\n\n    .notification {\n      position: absolute;\n      top: 12%;\n      left: 90%;\n      transform: translate(-50%, -50%);\n      background-color: #db340b;\n      width: 14px;\n      height: 14px;\n      border-radius: 50px;\n\n      font: {\n        family: Lato;\n        size: 8px;\n        weight: bold;\n      }\n\n      color: var(--sebrae-white);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  @media (min-width: 768px) {\n    margin-block: 24px;\n    border-radius: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
